import { useEffect, useState } from "react";

const API_BASE =
  process.env.REACT_APP_API_URL || "http://localhost:3001";

function dataHojeBR() {
  return new Date().toLocaleDateString("sv-SE", {
    timeZone: "America/Sao_Paulo",
  });
}

function normalizarUrl(url) {
  if (!url) return "";
  if (String(url).startsWith("http")) return url;
  if (String(url).startsWith("/uploads")) return `${API_BASE}${url}`;
  if (String(url).startsWith("uploads")) return `${API_BASE}/${url}`;
  return url;
}

function normalizarAnexosBancoRelatorio(relatorio = {}) {
  const anexosOriginais = Array.isArray(relatorio?.anexosBanco)
    ? relatorio.anexosBanco
    : [];

  const anexos = anexosOriginais
    .map((item, index) => {
      if (typeof item === "string") {
        return {
          url: normalizarUrl(item),
          tipo: "",
          nome: `Anexo ${index + 1}`,
          tamanho: 0,
        };
      }

      const url = normalizarUrl(
        item?.url ||
          item?.bancoPrintUrl ||
          item?.linkAnexo ||
          item?.arquivoUrl ||
          ""
      );

      if (!url) return null;

      return {
        url,
        tipo: item?.tipo || item?.bancoPrintTipo || item?.tipoArquivo || "",
        nome:
          item?.nome ||
          item?.originalname ||
          item?.filename ||
          `Anexo ${index + 1}`,
        tamanho: Number(item?.tamanho || item?.size || 0),
      };
    })
    .filter(Boolean);

  const urlLegada = normalizarUrl(
    relatorio?.bancoPrintUrl || relatorio?.linkAnexo || ""
  );

  if (urlLegada && !anexos.some((item) => item.url === urlLegada)) {
    anexos.unshift({
      url: urlLegada,
      tipo: relatorio?.bancoPrintTipo || "",
      nome: "Anexo do banco",
      tamanho: 0,
    });
  }

  const vistos = new Set();
  return anexos.filter((item) => {
    if (!item.url || vistos.has(item.url)) return false;
    vistos.add(item.url);
    return true;
  });
}

export default function Lancamentos() {
  const hoje = dataHojeBR();

  const [me, setMe] = useState(null);
  const [data, setData] = useState(hoje);
  const [faturamento, setFaturamento] = useState("");
  const [vendasNovas, setVendasNovas] = useState("");
  const [renovacoes, setRenovacoes] = useState("");
  const [leads, setLeads] = useState("");
  const [cobradosRenovacao, setCobradosRenovacao] = useState("");
  const [gastoTrafego, setGastoTrafego] = useState("");
  const [creditoServidor, setCreditoServidor] = useState("");
  const [devolucoes, setDevolucoes] = useState([{ descricao: "", valor: "", comprovanteUrl: "", comprovanteTipo: "" }]);
  const [outrosGastos, setOutrosGastos] = useState([
    {
      descricao: "",
      valor: "",
      comprovanteUrl: "",
      comprovanteTipo: "",
    },
  ]);
  const [relatorios, setRelatorios] = useState([]);
  const [relatorioAtual, setRelatorioAtual] = useState(null);
  const [resumoOperacaoHoje, setResumoOperacaoHoje] = useState(null);
  const [extratoDia, setExtratoDia] = useState([]);

  const [lendoComprovante, setLendoComprovante] = useState(false);
  const [confirmandoComprovante, setConfirmandoComprovante] = useState(false);
  const [popupComprovante, setPopupComprovante] = useState(null);
  const [tipoComprovante, setTipoComprovante] = useState("vendaNova");

  const [valorManual, setValorManual] = useState("");
  const [tipoManual, setTipoManual] = useState("vendaNova");
  const [salvandoManual, setSalvandoManual] = useState(false);

  // Compatibilidade: arquivoBanco continua representando o primeiro arquivo novo.
  // arquivosBanco/anexosBanco permitem múltiplos comprovantes sem quebrar o fluxo antigo.
  const [arquivoBanco, setArquivoBanco] = useState(null);
  const [arquivosBanco, setArquivosBanco] = useState([]);
  const [anexosBanco, setAnexosBanco] = useState([]);
  const [urlBanco, setUrlBanco] = useState("");
  const [tipoBanco, setTipoBanco] = useState("");
  const [valorBancoOCR, setValorBancoOCR] = useState(null);
  const [enviandoBanco, setEnviandoBanco] = useState(false);
  const [salvandoRelatorio, setSalvandoRelatorio] = useState(false);
  const [statusRelatorio, setStatusRelatorio] = useState("");
  const [royaltiesConfig, setRoyaltiesConfig] = useState({
    ativo: false,
    percentual: 30,
    tipo: "liquido",
  });

  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  function getTokenAtual() {
    return (
      localStorage.getItem("token") ||
      sessionStorage.getItem("token") ||
      ""
    );
  }

  function ehColaboradorUsuario(usuario = me) {
    const role = String(usuario?.role || "").toLowerCase();
    const plano = String(usuario?.plano || "").toLowerCase();

    return role === "colaborador" || plano.includes("colaborador");
  }

  function limparSessaoTokenInvalido() {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
  }

  function tratarRespostaTokenInvalido(resposta) {
    const mensagem = String(resposta?.error || resposta?.message || "").toLowerCase();

    if (
      mensagem.includes("token inválido") ||
      mensagem.includes("token invalido") ||
      mensagem.includes("jwt") ||
      mensagem.includes("unauthorized")
    ) {
      limparSessaoTokenInvalido();
      alert("Sessão expirada. Entre novamente.");
      window.location.href = "/login";
      return true;
    }

    return false;
  }

  function formatarMoeda(valor) {
    const somenteNumeros = String(valor || "").replace(/\D/g, "");
    if (!somenteNumeros) return "";
    const numero = Number(somenteNumeros) / 100;
    return numero.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function formatarNumeroComoMoeda(valor) {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function montarResumoLocalDoFormulario() {
    const faturamentoBrutoLocal = converterMoedaParaNumero(faturamento);

    const devolucoesFormatadas = montarDevolucoesFormatadas();
    const totalDevolucoesLocal = devolucoesFormatadas.reduce(
      (acc, item) => acc + Number(item.valor || 0),
      0
    );

    const faturamentoValidoLocal = Math.max(
      0,
      faturamentoBrutoLocal - totalDevolucoesLocal
    );

    const gastoTrafegoLocal = converterMoedaParaNumero(gastoTrafego);
    const creditoServidorLocal = converterMoedaParaNumero(creditoServidor);

    const outrosGastosFormatados = montarOutrosGastosFormatados();
    const totalOutrosGastosLocal = outrosGastosFormatados.reduce(
      (acc, item) => acc + Number(item.valor || 0),
      0
    );

    const totalGastosLocal = gastoTrafegoLocal + totalOutrosGastosLocal;
    const lucroLiquidoLocal = faturamentoValidoLocal - totalGastosLocal;

    const vendasNovasLocal = Number(vendasNovas || 0);
    const renovacoesLocal = Number(renovacoes || 0);

    return {
      faturamento: faturamentoValidoLocal,
      faturamentoBruto: faturamentoBrutoLocal,
      devolucoes: devolucoesFormatadas,
      totalDevolucoes: totalDevolucoesLocal,
      gastoTrafego: gastoTrafegoLocal,
      creditoServidor: creditoServidorLocal,
      outrosGastos: outrosGastosFormatados,
      totalOutrosGastos: totalOutrosGastosLocal,
      totalGastos: totalGastosLocal,
      lucroLiquido: lucroLiquidoLocal,
      lucroRealEmpresa: lucroLiquidoLocal - creditoServidorLocal,
      vendasNovas: vendasNovasLocal,
      renovacoes: renovacoesLocal,
      leads: Number(leads || 0),
      cobradosRenovacao: Number(cobradosRenovacao || 0),
      totalVendas: vendasNovasLocal + renovacoesLocal,
    };
  }

  function converterMoedaParaNumero(valor) {
    if (valor === null || valor === undefined || valor === "") return 0;
    if (typeof valor === "number") return valor;

    const texto = String(valor)
      .replace("R$", "")
      .replace(/\s/g, "")
      .replace(/\./g, "")
      .replace(",", ".");

    const numero = Number(texto);
    return Number.isNaN(numero) ? 0 : numero;
  }


  function numerosQuaseIguais(a, b, tolerancia = 0.01) {
    return Math.abs(Number(a || 0) - Number(b || 0)) <= tolerancia;
  }

  function somarColaboradoresIncluidos(snapshot) {
    const colaboradores = Array.isArray(snapshot?.colaboradoresIncluidos)
      ? snapshot.colaboradoresIncluidos
      : [];

    return colaboradores.reduce(
      (acc, colaborador) => {
        const vendasNovas = Number(colaborador.vendasNovas || 0);
        const renovacoes = Number(colaborador.renovacoes || 0);

        acc.faturamento += Number(colaborador.faturamento || 0);
        acc.vendasNovas += vendasNovas;
        acc.renovacoes += renovacoes;
        acc.leads += Number(colaborador.leads || 0);
        acc.cobradosRenovacao += Number(colaborador.cobradosRenovacao || 0);
        acc.totalVendas +=
          Number(colaborador.totalVendas || 0) || vendasNovas + renovacoes;

        return acc;
      },
      {
        faturamento: 0,
        vendasNovas: 0,
        renovacoes: 0,
        leads: 0,
        cobradosRenovacao: 0,
        totalVendas: 0,
      }
    );
  }

  function relatorioPareceSnapshotConsolidado(relatorio, snapshot) {
    if (!relatorio || !snapshot) return false;

    const colaboradores = somarColaboradoresIncluidos(snapshot);

    if (Number(colaboradores.faturamento || 0) <= 0) return false;

    return numerosQuaseIguais(relatorio.faturamento, snapshot.faturamento);
  }

  function descontarColaboradoresDoRelatorio(relatorio, snapshot) {
    if (!relatorio || !snapshot) return relatorio;

    const colaboradores = somarColaboradoresIncluidos(snapshot);

    const faturamentoIndividual = Math.max(
      0,
      Number(relatorio.faturamento || 0) - Number(colaboradores.faturamento || 0)
    );

    const vendasNovasIndividual = Math.max(
      0,
      Number(relatorio.vendasNovas || 0) - Number(colaboradores.vendasNovas || 0)
    );

    const renovacoesIndividual = Math.max(
      0,
      Number(relatorio.renovacoes || 0) - Number(colaboradores.renovacoes || 0)
    );

    const leadsIndividual = Math.max(
      0,
      Number(relatorio.leads || 0) - Number(colaboradores.leads || 0)
    );

    const cobradosRenovacaoIndividual = Math.max(
      0,
      Number(relatorio.cobradosRenovacao || 0) -
        Number(colaboradores.cobradosRenovacao || 0)
    );

    const totalVendasIndividual = vendasNovasIndividual + renovacoesIndividual;
    const gastoTrafegoIndividual = Number(relatorio.gastoTrafego || 0);
    const creditoServidorIndividual = Number(relatorio.creditoServidor || 0);
    const outrosGastosIndividual = Array.isArray(relatorio.outrosGastos)
      ? relatorio.outrosGastos
      : [];

    const totalOutrosGastosIndividual = outrosGastosIndividual.reduce(
      (acc, gasto) => acc + Number(gasto.valor || 0),
      0
    );

    const devolucoesIndividual = Array.isArray(relatorio.devolucoes)
      ? relatorio.devolucoes
      : [];

    const totalDevolucoesIndividual = devolucoesIndividual.reduce(
      (acc, item) => acc + Number(item.valor || 0),
      0
    );

    const faturamentoBrutoIndividual = Number(
      relatorio.faturamentoBruto ?? faturamentoIndividual + totalDevolucoesIndividual
    );

    const totalGastosIndividual =
      gastoTrafegoIndividual + totalOutrosGastosIndividual;

    const lucroLiquidoIndividual =
      faturamentoIndividual - totalGastosIndividual;

    return {
      ...relatorio,
      faturamento: faturamentoIndividual,
      faturamentoBruto: faturamentoBrutoIndividual,
      devolucoes: devolucoesIndividual,
      totalDevolucoes: totalDevolucoesIndividual,
      vendasNovas: vendasNovasIndividual,
      renovacoes: renovacoesIndividual,
      leads: leadsIndividual,
      cobradosRenovacao: cobradosRenovacaoIndividual,
      totalVendas: totalVendasIndividual,
      totalOutrosGastos: totalOutrosGastosIndividual,
      totalGastos: totalGastosIndividual,
      lucroLiquido: lucroLiquidoIndividual,
      lucroRealEmpresa: lucroLiquidoIndividual - creditoServidorIndividual,
      ticketMedio:
        totalVendasIndividual > 0
          ? faturamentoIndividual / totalVendasIndividual
          : 0,
      fechamentoOperacional: false,
      incluiColaboradores: false,
      colaboradoresIncluidos: [],
    };
  }

  function montarResumoOperacionalPorSnapshot(snapshot) {
    if (!snapshot) return null;

    const base = protegerRelatorioFormulario(snapshot, snapshot);
    const colaboradores = somarColaboradoresIncluidos(snapshot);

    const faturamento =
      Number(base?.faturamento || 0) + Number(colaboradores.faturamento || 0);
    const faturamentoBruto =
      Number(base?.faturamentoBruto ?? base?.faturamento ?? 0) +
      Number(colaboradores.faturamento || 0);
    const totalDevolucoes = Number(base?.totalDevolucoes || 0);
    const vendasNovas =
      Number(base?.vendasNovas || 0) + Number(colaboradores.vendasNovas || 0);
    const renovacoes =
      Number(base?.renovacoes || 0) + Number(colaboradores.renovacoes || 0);
    const leads =
      Number(base?.leads || 0) + Number(colaboradores.leads || 0);
    const cobradosRenovacao =
      Number(base?.cobradosRenovacao || 0) +
      Number(colaboradores.cobradosRenovacao || 0);
    const totalVendas = vendasNovas + renovacoes;

    const gastoTrafego = Number(base?.gastoTrafego || 0);
    const totalOutrosGastos = Number(base?.totalOutrosGastos || 0);
    const totalGastos = gastoTrafego + totalOutrosGastos;
    const lucroLiquido = faturamento - totalGastos;
    const creditoServidor = Number(base?.creditoServidor || 0);

    return {
      faturamento,
      faturamentoBruto,
      totalDevolucoes,
      gastoTrafego,
      totalOutrosGastos,
      totalGastos,
      lucroLiquido,
      creditoServidor,
      lucroRealEmpresa: lucroLiquido - creditoServidor,
      vendasNovas,
      renovacoes,
      leads,
      cobradosRenovacao,
      totalVendas,
    };
  }

  function protegerRelatorioFormulario(relatorio, snapshot = null) {
    if (!relatorio) return relatorio;

    // Se por algum motivo o backend devolver o próprio snapshot para o formulário,
    // usa a base individual guardada nele.
    if (relatorio.fechamentoOperacional || relatorio.incluiColaboradores) {
      const base = relatorio.baseIndividualFechamento;

      if (base && typeof base === "object") {
        const baseNormalizada = {
          ...relatorio,
          faturamento: Number(base.faturamento || 0),
          faturamentoBruto: Number(base.faturamentoBruto ?? base.faturamento ?? 0),
          devolucoes: Array.isArray(base.devolucoes) ? base.devolucoes : [],
          totalDevolucoes: Number(base.totalDevolucoes || 0),
          vendasNovas: Number(base.vendasNovas || 0),
          renovacoes: Number(base.renovacoes || 0),
          leads: Number(base.leads || 0),
          cobradosRenovacao: Number(base.cobradosRenovacao || 0),
          gastoTrafego: Number(base.gastoTrafego || 0),
          creditoServidor: Number(base.creditoServidor || 0),
          outrosGastos: Array.isArray(base.outrosGastos) ? base.outrosGastos : [],
          totalVendas:
            Number(base.totalVendas || 0) ||
            Number(base.vendasNovas || 0) + Number(base.renovacoes || 0),
          totalOutrosGastos: Number(base.totalOutrosGastos || 0),
          totalGastos: Number(base.totalGastos || 0),
          lucroLiquido: Number(base.lucroLiquido || 0),
          lucroRealEmpresa: Number(base.lucroRealEmpresa || 0),
          ticketMedio: Number(base.ticketMedio || 0),
          fechamentoOperacional: false,
          incluiColaboradores: false,
          colaboradoresIncluidos: [],
        };

        if (relatorioPareceSnapshotConsolidado(baseNormalizada, relatorio)) {
          return descontarColaboradoresDoRelatorio(baseNormalizada, relatorio);
        }

        return baseNormalizada;
      }
    }

    // Se o formulário veio com o mesmo faturamento do snapshot consolidado,
    // desconta os colaboradores. Isso corrige o bug do 26,11 descer para baixo
    // e depois virar 41,11 no reenvio.
    if (relatorioPareceSnapshotConsolidado(relatorio, snapshot)) {
      return descontarColaboradoresDoRelatorio(relatorio, snapshot);
    }

    return relatorio;
  }

  async function buscarSnapshotOperacionalDoDia(usuarioEmail, dataAlvo) {
    if (!usuarioEmail || !dataAlvo) return null;

    try {
      const res = await fetch(`${API_BASE}/meus-relatorios`, {
        headers: { Authorization: getTokenAtual() },
      });

      const resposta = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(resposta)) return null;

      if (!Array.isArray(resposta)) return null;

      const candidatos = resposta.filter((item) => {
        const colaboradoresIncluidos = Array.isArray(item?.colaboradoresIncluidos)
          ? item.colaboradoresIncluidos.length
          : 0;

        return (
          item?.usuario === usuarioEmail &&
          item?.data === dataAlvo &&
          (item?.fechamentoOperacional === true ||
            item?.incluiColaboradores === true ||
            colaboradoresIncluidos > 0)
        );
      });

      if (candidatos.length === 0) return null;

      return candidatos.sort((a, b) => {
        const dataA = new Date(a.updatedAt || a.createdAt || 0).getTime();
        const dataB = new Date(b.updatedAt || b.createdAt || 0).getTime();
        return dataB - dataA;
      })[0];
    } catch (err) {
      console.log("Não foi possível buscar snapshot operacional:", err);
      return null;
    }
  }

  function somarRelatorios(lista) {
    return lista.reduce(
      (acc, r) => {
        acc.faturamento += Number(r.faturamento || 0);
        acc.faturamentoBruto += Number(r.faturamentoBruto ?? r.faturamento ?? 0);
        acc.totalDevolucoes += Number(r.totalDevolucoes || 0);
        acc.gastoTrafego += Number(r.gastoTrafego || 0);
        acc.totalOutrosGastos += Number(r.totalOutrosGastos || 0);
        acc.totalGastos += Number(r.totalGastos || 0);
        acc.lucroLiquido += Number(r.lucroLiquido || 0);
        acc.creditoServidor += Number(r.creditoServidor || 0);
        acc.lucroRealEmpresa +=
          Number(r.lucroLiquido || 0) - Number(r.creditoServidor || 0);
        acc.vendasNovas += Number(r.vendasNovas || 0);
        acc.renovacoes += Number(r.renovacoes || 0);
        acc.leads += Number(r.leads || 0);
        acc.cobradosRenovacao += Number(r.cobradosRenovacao || 0);
        acc.totalVendas += Number(r.totalVendas || 0);
        return acc;
      },
      {
        faturamento: 0,
        faturamentoBruto: 0,
        totalDevolucoes: 0,
        gastoTrafego: 0,
        totalOutrosGastos: 0,
        totalGastos: 0,
        lucroLiquido: 0,
        creditoServidor: 0,
        lucroRealEmpresa: 0,
        vendasNovas: 0,
        renovacoes: 0,
        leads: 0,
        cobradosRenovacao: 0,
        totalVendas: 0,
      }
    );
  }

  async function carregarMe() {
    const res = await fetch(`${API_BASE}/me`, {
      headers: { Authorization: getTokenAtual() },
    });

    const usuario = await res.json();

    if (!res.ok && tratarRespostaTokenInvalido(usuario)) return null;

    setMe(usuario);
    return usuario;
  }

  async function carregarConfiguracoesRoyalties() {
    if (!getTokenAtual()) return;

    try {
      const res = await fetch(`${API_BASE}/configuracoes`, {
        headers: { Authorization: getTokenAtual() },
      });

      const dados = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(dados)) return;

      const royalties = dados?.royalties || {};

      setRoyaltiesConfig({
        ativo: Boolean(royalties.ativo),
        percentual: Number(royalties.percentual || 30),
        tipo: royalties.tipo === "bruto" ? "bruto" : "liquido",
      });
    } catch (err) {
      console.log("Erro ao carregar royalties:", err);
    }
  }

  async function carregarExtratoDoDia() {
    if (!getTokenAtual() || !data) return [];

    try {
      const res = await fetch(`${API_BASE}/extrato-lancamentos-dia?data=${data}`, {
        headers: { Authorization: getTokenAtual() },
      });

      const resposta = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(resposta)) return [];

      if (Array.isArray(resposta)) {
        setExtratoDia(resposta);
        return resposta;
      }

      setExtratoDia([]);
      return [];
    } catch (err) {
      console.log("Erro ao carregar extrato do dia:", err);
      setExtratoDia([]);
      return [];
    }
  }

  async function carregarRelatorioDoDia() {
    const res = await fetch(`${API_BASE}/relatorio-diario?data=${data}`, {
      headers: { Authorization: getTokenAtual() },
    });

    const respostaRelatorio = await res.json();

    if (!res.ok && tratarRespostaTokenInvalido(respostaRelatorio)) return;

    let relatorio = respostaRelatorio;

    if (relatorio) {
      const usuarioAtual = me || (await carregarMe());
      const snapshotDoDia = await buscarSnapshotOperacionalDoDia(
        usuarioAtual?.email,
        data
      );

      relatorio = protegerRelatorioFormulario(relatorio, snapshotDoDia);
    }

    setRelatorioAtual(relatorio || null);

    if (relatorio) {
      setFaturamento(formatarNumeroComoMoeda(relatorio.faturamentoBruto ?? relatorio.faturamento));
      setVendasNovas(relatorio.vendasNovas || "");
      setRenovacoes(relatorio.renovacoes || "");
      setLeads(relatorio.leads || "");
      setCobradosRenovacao(relatorio.cobradosRenovacao || "");
      setGastoTrafego(formatarNumeroComoMoeda(relatorio.gastoTrafego));
      setCreditoServidor(formatarNumeroComoMoeda(relatorio.creditoServidor || 0));

      const anexosBancoCarregados = normalizarAnexosBancoRelatorio(relatorio);
      const primeiroAnexoBanco = anexosBancoCarregados[0] || null;

      setAnexosBanco(anexosBancoCarregados);
      setArquivosBanco([]);
      setArquivoBanco(null);
      setUrlBanco(primeiroAnexoBanco?.url || "");
      setTipoBanco(primeiroAnexoBanco?.tipo || "");
      setValorBancoOCR(
        relatorio.valorOcrBanco === null || relatorio.valorOcrBanco === undefined
          ? null
          : Number(relatorio.valorOcrBanco)
      );

      setStatusRelatorio(textoStatusDoDia(relatorio));

      setDevolucoes(
        relatorio.devolucoes && relatorio.devolucoes.length > 0
          ? relatorio.devolucoes.map((item) => ({
              descricao: item.descricao || "",
              valor: formatarNumeroComoMoeda(item.valor),
              comprovanteUrl: item.comprovanteUrl || item.arquivoUrl || "",
              comprovanteTipo: item.comprovanteTipo || item.tipoArquivo || "",
            }))
          : [{ descricao: "", valor: "", comprovanteUrl: "", comprovanteTipo: "" }]
      );

      setOutrosGastos(
        relatorio.outrosGastos && relatorio.outrosGastos.length > 0
          ? relatorio.outrosGastos.map((gasto) => ({
              descricao: gasto.descricao || "",
              valor: formatarNumeroComoMoeda(gasto.valor),
              comprovanteUrl: gasto.comprovanteUrl || "",
              comprovanteTipo: gasto.comprovanteTipo || "",
            }))
          : [
              {
                descricao: "",
                valor: "",
                comprovanteUrl: "",
                comprovanteTipo: "",
              },
            ]
      );
    } else {
      setFaturamento("");
      setVendasNovas("");
      setRenovacoes("");
      setLeads("");
      setCobradosRenovacao("");
      setGastoTrafego("");
      setCreditoServidor("");
      setDevolucoes([{ descricao: "", valor: "", comprovanteUrl: "", comprovanteTipo: "" }]);
      setOutrosGastos([{ descricao: "", valor: "" }]);
      setArquivoBanco(null);
      setArquivosBanco([]);
      setAnexosBanco([]);
      setUrlBanco("");
      setTipoBanco("");
      setStatusRelatorio("Ainda não iniciado");
    }

    await carregarExtratoDoDia();
  }

  function preencherFormularioComRelatorio(relatorio, statusForcado = null) {
    if (!relatorio) return;

    setRelatorioAtual(relatorio || null);
    setFaturamento(formatarNumeroComoMoeda(relatorio.faturamentoBruto ?? relatorio.faturamento));
    setVendasNovas(relatorio.vendasNovas || "");
    setRenovacoes(relatorio.renovacoes || "");
    setLeads(relatorio.leads || "");
    setCobradosRenovacao(relatorio.cobradosRenovacao || "");
    setGastoTrafego(formatarNumeroComoMoeda(relatorio.gastoTrafego));
    setCreditoServidor(formatarNumeroComoMoeda(relatorio.creditoServidor || 0));

    const anexosBancoCarregados = normalizarAnexosBancoRelatorio(relatorio);
    const primeiroAnexoBanco = anexosBancoCarregados[0] || null;

    setAnexosBanco(anexosBancoCarregados);
    // Não limpa arquivos ainda não enviados ao apenas atualizar o rascunho.
    // No fechamento, uploadPrintBanco() já limpa a seleção após concluir o upload.
    setUrlBanco(primeiroAnexoBanco?.url || "");
    setTipoBanco(primeiroAnexoBanco?.tipo || "");
    setValorBancoOCR(
      relatorio.valorOcrBanco === null || relatorio.valorOcrBanco === undefined
        ? null
        : Number(relatorio.valorOcrBanco)
    );

    if (statusForcado) {
      setStatusRelatorio(statusForcado);
    } else {
      setStatusRelatorio(textoStatusDoDia(relatorio));
    }

    setDevolucoes(
      relatorio.devolucoes && relatorio.devolucoes.length > 0
        ? relatorio.devolucoes.map((item) => ({
            descricao: item.descricao || "",
            valor: formatarNumeroComoMoeda(item.valor),
            comprovanteUrl: item.comprovanteUrl || item.arquivoUrl || "",
            comprovanteTipo: item.comprovanteTipo || item.tipoArquivo || "",
          }))
        : [{ descricao: "", valor: "", comprovanteUrl: "", comprovanteTipo: "" }]
    );

    setOutrosGastos(
      relatorio.outrosGastos && relatorio.outrosGastos.length > 0
        ? relatorio.outrosGastos.map((gasto) => ({
            descricao: gasto.descricao || "",
            valor: formatarNumeroComoMoeda(gasto.valor),
            comprovanteUrl: gasto.comprovanteUrl || "",
            comprovanteTipo: gasto.comprovanteTipo || "",
          }))
        : [
              {
                descricao: "",
                valor: "",
                comprovanteUrl: "",
                comprovanteTipo: "",
              },
            ]
    );
  }

  async function carregarRelatorios(usuarioAtual = me) {
    const usuarioBase = usuarioAtual || me;

    if (!usuarioBase?.email) return;

    // IMPORTANTE:
    // Ao trocar a data, limpa o resumo anterior para não ficar mostrando
    // cards congelados de hoje enquanto carrega o dia selecionado.
    setResumoOperacaoHoje(null);

    const res = await fetch(`${API_BASE}/meus-relatorios`, {
      headers: { Authorization: getTokenAtual() },
    });

    const resposta = await res.json();

    if (!res.ok && tratarRespostaTokenInvalido(resposta)) return;

    if (!Array.isArray(resposta)) {
      setResumoOperacaoHoje(somarRelatorios([]));
      setRelatorios([]);
      return;
    }

    function ehMeu(item) {
      return item.usuario === usuarioBase?.email;
    }

    function ehColaboradorDireto(item) {
      return (
        item.role === "colaborador" &&
        String(item.parentId) === String(usuarioBase?.id)
      );
    }

    function relatorioEhConsolidado(r) {
      const colaboradoresIncluidos = Array.isArray(r?.colaboradoresIncluidos)
        ? r.colaboradoresIncluidos.length
        : 0;

      return (
        r?.incluiColaboradores === true ||
        r?.fechamentoOperacional === true ||
        (r?.fechado === true && colaboradoresIncluidos > 0)
      );
    }

    function relatorioConsolidadoAtivo(r) {
      if (!relatorioEhConsolidado(r)) return false;

      const status = String(r?.statusAprovacao || "");

      // Snapshot operacional continua valendo enquanto estiver pendente ou aprovado.
      // Rejeitado/correção volta para base individual + colaboradores diretos.
      return status === "pendente" || status === "aprovado";
    }

    function normalizarOperacao(lista) {
      const porData = {};

      lista.forEach((item) => {
        if (!item.data) return;

        if (!porData[item.data]) {
          porData[item.data] = {
            meus: [],
            colaboradores: [],
          };
        }

        if (ehMeu(item)) {
          porData[item.data].meus.push(item);
        }

        if (ehColaboradorDireto(item)) {
          porData[item.data].colaboradores.push(item);
        }
      });

      const final = [];

      Object.values(porData).forEach((grupo) => {
        const snapshotsDoDono = grupo.meus
          .filter(relatorioEhConsolidado)
          .sort((a, b) => {
            const dataA = new Date(a.updatedAt || a.createdAt || 0).getTime();
            const dataB = new Date(b.updatedAt || b.createdAt || 0).getTime();
            return dataB - dataA;
          });

        const relatorioConsolidado = snapshotsDoDono.find(relatorioConsolidadoAtivo);
        const snapshotRejeitadoOuCorrecao = snapshotsDoDono.find((item) => {
          const status = String(item?.statusAprovacao || "");
          return status === "rejeitado" || status === "aguardando_correcao";
        });

        if (relatorioConsolidado) {
          final.push(relatorioConsolidado);
        } else {
          const meusBase = grupo.meus
            .filter((item) => !relatorioEhConsolidado(item))
            .map((item) => {
              // Quando o fechamento é rejeitado, alguns retornos ainda vêm com
              // a base individual contaminada pelo consolidado. Para os cards,
              // aplica a mesma proteção do formulário: desconta colaboradores
              // do snapshot rejeitado/correção antes de somar com os colaboradores vivos.
              if (snapshotRejeitadoOuCorrecao) {
                return protegerRelatorioFormulario(item, snapshotRejeitadoOuCorrecao);
              }

              return item;
            });

          final.push(...meusBase);
          final.push(...grupo.colaboradores.filter((item) => !relatorioEhConsolidado(item)));
        }
      });

      return final;
    }

    function resumoDoBackendParaCards(item) {
      if (!item || typeof item !== "object") return null;

      const faturamentoResumo = Number(item.faturamento || 0);
      const gastosResumo = Number(item.totalGastos ?? item.gastos ?? 0);
      const lucroResumo = Number(
        item.lucroLiquido ?? item.lucro ?? faturamentoResumo - gastosResumo
      );
      const vendasNovasResumo = Number(item.vendasNovas || 0);
      const renovacoesResumo = Number(item.renovacoes || 0);
      const vendasResumo = Number(
        item.totalVendas ?? item.vendas ?? vendasNovasResumo + renovacoesResumo
      );

      return {
        faturamento: faturamentoResumo,
        faturamentoBruto: Number(item.faturamentoBruto ?? faturamentoResumo),
        totalDevolucoes: Number(item.totalDevolucoes || 0),
        gastoTrafego: Number(item.gastoTrafego || 0),
        totalOutrosGastos: Number(item.totalOutrosGastos || 0),
        totalGastos: gastosResumo,
        lucroLiquido: lucroResumo,
        creditoServidor: Number(item.creditoServidor || 0),
        lucroRealEmpresa: Number(
          item.lucroRealEmpresa ?? lucroResumo - Number(item.creditoServidor || 0)
        ),
        vendasNovas: vendasNovasResumo,
        renovacoes: renovacoesResumo,
        leads: Number(item.leads || 0),
        cobradosRenovacao: Number(item.cobradosRenovacao || 0),
        totalVendas: vendasResumo,
      };
    }

    const meusBase = resposta.filter((item) => {
      return ehMeu(item) || ehColaboradorDireto(item);
    });

    const snapshotsRejeitadosOuCorrecaoDoDia = resposta
      .filter((item) => {
        const colaboradoresIncluidos = Array.isArray(item?.colaboradoresIncluidos)
          ? item.colaboradoresIncluidos.length
          : 0;

        const ehConsolidado =
          item?.incluiColaboradores === true ||
          item?.fechamentoOperacional === true ||
          (item?.fechado === true && colaboradoresIncluidos > 0);

        const status = String(item?.statusAprovacao || "");

        return (
          item?.usuario === usuarioBase?.email &&
          item?.data === data &&
          ehConsolidado &&
          (status === "rejeitado" || status === "aguardando_correcao")
        );
      })
      .sort((a, b) => {
        const dataA = new Date(a.updatedAt || a.createdAt || 0).getTime();
        const dataB = new Date(b.updatedAt || b.createdAt || 0).getTime();
        return dataB - dataA;
      });

    const snapshotRejeitadoOuCorrecaoDoDia =
      snapshotsRejeitadosOuCorrecaoDoDia[0] || null;

    const temSnapshotRejeitadoOuCorrecaoNoDia = Boolean(
      snapshotRejeitadoOuCorrecaoDoDia
    );

    const meusRelatorios = normalizarOperacao(meusBase);

    const relatoriosDoDiaDaOperacao = meusRelatorios.filter(
      (item) => item.data === data
    );

    let resumoHojeFinal = somarRelatorios(relatoriosDoDiaDaOperacao);

    // Quando o master rejeita/correção, o /meus-relatorios pode demorar a
    // devolver as bases vivas completas e os cards podem zerar até clicar no
    // botão azul. Nesse caso, reconstruímos imediatamente os cards a partir do
    // próprio snapshot rejeitado: base individual protegida + colaboradores.
    if (
      temSnapshotRejeitadoOuCorrecaoNoDia &&
      Number(resumoHojeFinal?.faturamento || 0) <= 0
    ) {
      const resumoPorSnapshot = montarResumoOperacionalPorSnapshot(
        snapshotRejeitadoOuCorrecaoDoDia
      );

      if (resumoPorSnapshot) {
        resumoHojeFinal = resumoPorSnapshot;
      }
    }

    // Fonte mais confiável para os cards de HOJE: mesma base do Dashboard.
    // ATENÇÃO:
    // /minha-rede retorna resumo de hoje. Para datas antigas, NÃO pode sobrescrever
    // os cards históricos, senão a tela fica presa/congelada no dia atual.
    if (data === hoje && usuarioBase?.role !== "colaborador" && usuarioBase?.id) {
      try {
        const resRede = await fetch(`${API_BASE}/minha-rede/${usuarioBase.id}`, {
          headers: { Authorization: getTokenAtual() },
        });

        const dadosRede = await resRede.json();

        if (!resRede.ok && tratarRespostaTokenInvalido(dadosRede)) return;

        if (resRede.ok) {
          const resumoHojeBackend =
            dadosRede?.resumoMeuGrupo?.hoje ||
            dadosRede?.resumoIndividual?.hoje ||
            dadosRede?.resumoSomenteUsuario?.hoje ||
            null;

          const convertido = resumoDoBackendParaCards(resumoHojeBackend);

          if (convertido) {
            // Nunca deixa a fonte /minha-rede diminuir os cards quando o
            // /meus-relatorios já somou corretamente pai + colaboradores.
            // Isso acontecia depois do fechamento pendente: /minha-rede voltava
            // só o individual e "apagava" o colaborador dos cards de cima.
            const fatLocal = Number(resumoHojeFinal?.faturamento || 0);
            const fatBackend = Number(convertido?.faturamento || 0);
            const vendasLocal = Number(resumoHojeFinal?.totalVendas || 0);
            const vendasBackend = Number(convertido?.totalVendas || 0);

            const temDevolucaoLocal = Number(resumoHojeFinal?.totalDevolucoes || 0) > 0;

            if (
              !temSnapshotRejeitadoOuCorrecaoNoDia &&
              !temDevolucaoLocal &&
              (fatLocal <= 0 || fatBackend > fatLocal || vendasBackend > vendasLocal)
            ) {
              resumoHojeFinal = convertido;
            }
          }
        }
      } catch (err) {
        console.log("Fallback cards Lançamentos /meus-relatorios:", err);
      }
    }

    setResumoOperacaoHoje(resumoHojeFinal);

    setRelatorios(
      meusRelatorios.sort((a, b) =>
        String(b.data).localeCompare(String(a.data))
      )
    );
  }

  function atualizarDevolucao(index, campo, valor) {
    const novasDevolucoes = [...devolucoes];
    novasDevolucoes[index][campo] = campo === "valor" ? formatarMoeda(valor) : valor;
    setDevolucoes(novasDevolucoes);
  }

  function adicionarDevolucao() {
    setDevolucoes([
      ...devolucoes,
      { descricao: "", valor: "", comprovanteUrl: "", comprovanteTipo: "" },
    ]);
  }

  function removerDevolucao(index) {
    setDevolucoes(devolucoes.filter((_, i) => i !== index));
  }

  function temDevolucaoSemDescricao() {
    return devolucoes.some(
      (item) =>
        converterMoedaParaNumero(item.valor) > 0 && !item.descricao.trim()
    );
  }


  async function uploadComprovanteDevolucao(index, arquivo) {
    if (!arquivo) return;

    try {
      const formData = new FormData();
      formData.append("arquivo", arquivo);

      const res = await fetch(`${API_BASE}/relatorio-diario/anexar-banco?ocrBanco=1`, {
        method: "POST",
        headers: { Authorization: getTokenAtual() },
        body: formData,
      });

      const dados = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(dados)) return;

      if (!res.ok) {
        throw new Error(dados.error || "Erro ao enviar comprovante.");
      }

      const novasDevolucoes = [...devolucoes];

      novasDevolucoes[index].comprovanteUrl =
        dados.bancoPrintUrl ||
        dados.url ||
        dados.arquivoUrl ||
        "";

      novasDevolucoes[index].comprovanteTipo =
        arquivo.type || "";

      setDevolucoes(novasDevolucoes);
    } catch (error) {
      console.error(error);
      alert("Erro ao enviar comprovante da devolução");
    }
  }

  async function uploadComprovanteOutroGasto(index, arquivo) {
    if (!arquivo) return;

    try {
      const formData = new FormData();
      formData.append("arquivo", arquivo);

      const res = await fetch(`${API_BASE}/relatorio-diario/anexar-banco`, {
        method: "POST",
        headers: { Authorization: getTokenAtual() },
        body: formData,
      });

      const dados = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(dados)) return;

      if (!res.ok) {
        throw new Error(dados.error || "Erro ao enviar comprovante.");
      }

      const novosGastos = [...outrosGastos];

      novosGastos[index].comprovanteUrl =
        dados.bancoPrintUrl ||
        dados.url ||
        dados.arquivoUrl ||
        "";

      novosGastos[index].comprovanteTipo =
        arquivo.type || "";

      setOutrosGastos(novosGastos);
    } catch (error) {
      console.error(error);
      alert("Erro ao enviar comprovante do gasto");
    }
  }

  function montarDevolucoesFormatadas() {
    return devolucoes
      .map((item) => ({
        descricao: item.descricao,
        valor: converterMoedaParaNumero(item.valor),
        comprovanteUrl: item.comprovanteUrl || "",
        comprovanteTipo: item.comprovanteTipo || "",
      }))
      .filter(
        (item) =>
          item.descricao.trim() ||
          item.valor > 0 ||
          item.comprovanteUrl
      );
  }

  function atualizarOutroGasto(index, campo, valor) {
    const novosGastos = [...outrosGastos];
    novosGastos[index][campo] =
      campo === "valor" ? formatarMoeda(valor) : valor;
    setOutrosGastos(novosGastos);
  }

  function adicionarOutroGasto() {
    setOutrosGastos([
      ...outrosGastos,
      {
        descricao: "",
        valor: "",
        comprovanteUrl: "",
        comprovanteTipo: "",
      },
    ]);
  }

  function removerOutroGasto(index) {
    setOutrosGastos(outrosGastos.filter((_, i) => i !== index));
  }

  function temOutroGastoSemDescricao() {
    return outrosGastos.some(
      (gasto) =>
        converterMoedaParaNumero(gasto.valor) > 0 && !gasto.descricao.trim()
    );
  }

  function montarOutrosGastosFormatados() {
    return outrosGastos
      .map((gasto) => ({
        descricao: gasto.descricao,
        valor: converterMoedaParaNumero(gasto.valor),
        comprovanteUrl: gasto.comprovanteUrl || "",
        comprovanteTipo: gasto.comprovanteTipo || "",
      }))
      .filter((gasto) => gasto.descricao.trim() || gasto.valor > 0);
  }

  function arquivoPermitidoBanco(arquivo) {
    if (!arquivo) return false;

    const tipo = String(arquivo.type || "").toLowerCase();
    const nome = String(arquivo.name || "").toLowerCase();

    if (tipo.startsWith("image/")) return true;
    if (tipo === "application/pdf") return true;

    return [".png", ".jpg", ".jpeg", ".webp", ".heic", ".heif", ".pdf"].some(
      (ext) => nome.endsWith(ext)
    );
  }

  async function lerRespostaJsonSegura(res) {
    const texto = await res.text();

    if (!texto) return {};

    try {
      return JSON.parse(texto);
    } catch {
      return { error: texto };
    }
  }

  function aguardar(ms = 300) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }


  function nomeArquivoSeguroBanco(arquivo) {
    const nomeOriginal = String(arquivo?.name || "").trim();
    const tipo = String(arquivo?.type || "").toLowerCase();

    let extensao = "";

    if (nomeOriginal.includes(".")) {
      extensao = nomeOriginal.slice(nomeOriginal.lastIndexOf(".")).toLowerCase();
    }

    if (!extensao) {
      if (tipo.includes("png")) extensao = ".png";
      else if (tipo.includes("webp")) extensao = ".webp";
      else if (tipo.includes("pdf")) extensao = ".pdf";
      else extensao = ".jpg";
    }

    const base = nomeOriginal
      ? nomeOriginal.replace(/\.[^.]+$/, "")
      : `fechamento-banco-${data}`;

    const nomeLimpo = base
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-zA-Z0-9._-]/g, "-")
      .replace(/-+/g, "-")
      .slice(0, 70);

    return `${nomeLimpo || "fechamento-banco"}${extensao}`;
  }

  function tipoArquivoSeguroBanco(arquivo) {
    const tipo = String(arquivo?.type || "").toLowerCase();
    const nome = String(arquivo?.name || "").toLowerCase();

    if (tipo) return tipo;
    if (nome.endsWith(".png")) return "image/png";
    if (nome.endsWith(".webp")) return "image/webp";
    if (nome.endsWith(".pdf")) return "application/pdf";
    if (nome.endsWith(".jpg") || nome.endsWith(".jpeg")) return "image/jpeg";

    return "application/octet-stream";
  }

  function prepararArquivoBancoOriginal(arquivo) {
    if (!arquivo) return arquivo;

    // Não altera os pixels da imagem.
    // Apenas garante nome/tipo seguros para evitar falha de upload em alguns Androids.
    const nomeSeguro = nomeArquivoSeguroBanco(arquivo);
    const tipoSeguro = tipoArquivoSeguroBanco(arquivo);

    if (arquivo.name === nomeSeguro && arquivo.type === tipoSeguro) {
      return arquivo;
    }

    return new File([arquivo], nomeSeguro, {
      type: tipoSeguro,
      lastModified: arquivo.lastModified || Date.now(),
    });
  }

  async function enviarArquivoBancoFetch(arquivoParaEnviar, tokenAtual) {
    const formData = new FormData();

    formData.append(
      "arquivo",
      arquivoParaEnviar,
      arquivoParaEnviar.name || `fechamento-banco-${data}`
    );

    let res;

    try {
      res = await fetch(`${API_BASE}/relatorio-diario/anexar-banco`, {
        method: "POST",
        headers: {
          Authorization: tokenAtual,
        },
        body: formData,
      });
    } catch {
      throw new Error("Falha de conexão ao enviar o print do banco.");
    }

    const resposta = await lerRespostaJsonSegura(res);

    if (!res.ok && tratarRespostaTokenInvalido(resposta)) {
      throw new Error("Sessão expirada. Entre novamente.");
    }

    if (!res.ok) {
      throw new Error(resposta.error || "Erro ao anexar print");
    }

    return resposta;
  }

  function enviarArquivoBancoXHR(arquivoParaEnviar, tokenAtual, opcoes = {}) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      formData.append(
        "arquivo",
        arquivoParaEnviar,
        arquivoParaEnviar.name || `fechamento-banco-${data}`
      );

      const xhr = new XMLHttpRequest();

      // O upload precisa terminar rápido no celular. A leitura OCR ocorre no
      // fechamento, usando o arquivo já salvo, em vez de manter o envio aberto.
      const sufixoOCR = opcoes.lerOCR ? "?ocrBanco=1" : "";
      xhr.open("POST", `${API_BASE}/relatorio-diario/anexar-banco${sufixoOCR}`);
      xhr.setRequestHeader("Authorization", tokenAtual);

      xhr.onload = () => {
        try {
          const json = JSON.parse(xhr.responseText || "{}");

          if (xhr.status >= 200 && xhr.status < 300) {
            resolve(json);
          } else if (tratarRespostaTokenInvalido(json)) {
            reject(new Error("Sessão expirada. Entre novamente."));
          } else {
            reject(new Error(json.error || "Erro ao anexar print"));
          }
        } catch {
          reject(new Error("Erro ao processar resposta do servidor"));
        }
      };

      xhr.onerror = () => {
        reject(new Error("Falha de conexão ao enviar o print do banco."));
      };

      xhr.send(formData);
    });
  }

  function arquivoEhImagemRasterBanco(arquivo) {
    if (!arquivo) return false;

    const tipo = String(arquivo.type || "").toLowerCase();
    const nome = String(arquivo.name || "").toLowerCase();

    if (tipo === "application/pdf" || nome.endsWith(".pdf")) return false;
    if (tipo.includes("heic") || tipo.includes("heif")) return false;
    if (nome.endsWith(".heic") || nome.endsWith(".heif")) return false;

    return tipo.startsWith("image/") || /\.(png|jpe?g|webp)$/i.test(nome);
  }

  function carregarImagemBancoDeArquivo(arquivo) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(arquivo);
      const img = new Image();

      img.onload = () => {
        URL.revokeObjectURL(url);
        resolve(img);
      };

      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("Não consegui preparar a imagem do banco para envio."));
      };

      img.src = url;
    });
  }

  function blobImagemParecePreto(blob) {
    return new Promise((resolve) => {
      const url = URL.createObjectURL(blob);
      const img = new Image();

      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          const tamanho = 80;
          canvas.width = tamanho;
          canvas.height = tamanho;

          const ctx = canvas.getContext("2d", { willReadFrequently: true });
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, tamanho, tamanho);
          ctx.drawImage(img, 0, 0, tamanho, tamanho);

          const pixels = ctx.getImageData(0, 0, tamanho, tamanho).data;
          let somaBrilho = 0;
          let pixelsEscuros = 0;
          let total = 0;

          for (let i = 0; i < pixels.length; i += 4) {
            const r = pixels[i];
            const g = pixels[i + 1];
            const b = pixels[i + 2];
            const a = pixels[i + 3];

            if (a < 20) continue;

            const brilho = (r + g + b) / 3;
            somaBrilho += brilho;
            total += 1;

            if (brilho < 22) pixelsEscuros += 1;
          }

          URL.revokeObjectURL(url);

          if (!total) {
            resolve(false);
            return;
          }

          const media = somaBrilho / total;
          const proporcaoEscura = pixelsEscuros / total;

          // Proteção contra o bug da tela preta: se a conversão gerar uma imagem
          // praticamente toda preta, ela é descartada e não é enviada.
          resolve(media < 28 && proporcaoEscura > 0.88);
        } catch {
          URL.revokeObjectURL(url);
          resolve(false);
        }
      };

      img.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(false);
      };

      img.src = url;
    });
  }

  async function criarArquivoBancoLeveSeguro(arquivo) {
    if (!arquivoEhImagemRasterBanco(arquivo)) return null;

    const img = await carregarImagemBancoDeArquivo(arquivo);

    const maxLado = 1600;
    let width = img.naturalWidth || img.width;
    let height = img.naturalHeight || img.height;

    if (!width || !height) return null;

    if (width > height && width > maxLado) {
      height = Math.round((height * maxLado) / width);
      width = maxLado;
    } else if (height >= width && height > maxLado) {
      width = Math.round((width * maxLado) / height);
      height = maxLado;
    }

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, width, height);
    ctx.drawImage(img, 0, 0, width, height);

    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, "image/jpeg", 0.82);
    });

    if (!blob) return null;

    const virouPreto = await blobImagemParecePreto(blob);

    if (virouPreto) {
      console.log("Compressão segura cancelada: imagem convertida ficou preta.");
      return null;
    }

    if (blob.size >= arquivo.size && arquivo.size <= 8 * 1024 * 1024) {
      return null;
    }

    const nomeBase = String(arquivo.name || `fechamento-banco-${data}`)
      .replace(/\.[^.]+$/, "")
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-zA-Z0-9._-]/g, "-")
      .replace(/-+/g, "-")
      .slice(0, 70);

    return new File([blob], `${nomeBase || "fechamento-banco"}-mobile.jpg`, {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
  }

  function estaNoCelular() {
    const userAgent = String(navigator.userAgent || "");
    const telaPequena = Math.min(window.innerWidth || 0, window.innerHeight || 0) <= 820;

    return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent) || telaPequena;
  }

  async function prepararArquivoBancoParaEnvio(arquivo) {
    const tamanhoMinimoParaOtimizar = 1.5 * 1024 * 1024;

    if (
      !estaNoCelular() ||
      !arquivoEhImagemRasterBanco(arquivo) ||
      Number(arquivo?.size || 0) < tamanhoMinimoParaOtimizar
    ) {
      return arquivo;
    }

    try {
      const arquivoLeve = await criarArquivoBancoLeveSeguro(arquivo);

      if (arquivoLeve) {
        console.log(
          `Print do banco otimizado para celular: ${Math.round(arquivo.size / 1024)}KB → ${Math.round(arquivoLeve.size / 1024)}KB`
        );
        return arquivoLeve;
      }
    } catch (err) {
      // Se o navegador não conseguir preparar a imagem, o envio do original
      // continua disponível e não bloqueia o fechamento.
      console.log("Não foi possível otimizar o print no celular. Enviando original:", err);
    }

    return arquivo;
  }

  async function enviarArquivoBancoComFallback(arquivoParaEnviar, tokenAtual, opcoes = {}) {
    let erroXHR = null;
    let erroFetch = null;

    try {
      return await enviarArquivoBancoXHR(arquivoParaEnviar, tokenAtual, opcoes);
    } catch (err) {
      erroXHR = err;
      console.log("Upload via XHR falhou, tentando fetch com arquivo original:", err);
    }

    try {
      return await enviarArquivoBancoFetch(arquivoParaEnviar, tokenAtual);
    } catch (err) {
      erroFetch = err;
      console.log("Upload original via fetch falhou. Tentando arquivo leve seguro no celular:", err);
    }

    const arquivoLeve = await criarArquivoBancoLeveSeguro(arquivoParaEnviar);

    if (arquivoLeve) {
      try {
        return await enviarArquivoBancoXHR(arquivoLeve, tokenAtual, opcoes);
      } catch (err) {
        console.log("Upload do arquivo leve via XHR falhou, tentando fetch:", err);
      }

      try {
        return await enviarArquivoBancoFetch(arquivoLeve, tokenAtual);
      } catch (err) {
        console.log("Upload do arquivo leve via fetch também falhou:", err);
      }
    }

    throw new Error(
      erroFetch?.message ||
        erroXHR?.message ||
        "Falha de conexão ao enviar o print do banco pelo celular."
    );
  }



  function anexoBancoSalvoPorSlot(slot = 0) {
    const lista = Array.isArray(anexosBanco) ? anexosBanco : [];
    const nomeProcurado = slot === 1 ? "outro" : "inter";

    const encontrado = lista.find((item) =>
      String(item?.nome || "").toLowerCase().includes(nomeProcurado)
    );

    if (encontrado) return encontrado;

    return lista[slot] || null;
  }

  async function uploadPrintBanco() {
    const anexosExistentes = Array.isArray(anexosBanco) ? anexosBanco : [];
    const nomesSlots = ["Banco Inter", "Outro banco"];

    const arquivosPorSlot = [
      Array.isArray(arquivosBanco) ? arquivosBanco[0] || null : null,
      Array.isArray(arquivosBanco) ? arquivosBanco[1] || null : null,
    ];

    // Compatibilidade com o estado antigo de um único arquivo.
    if (!arquivosPorSlot[0] && !arquivosPorSlot[1] && arquivoBanco) {
      arquivosPorSlot[0] = arquivoBanco;
    }

    const possuiArquivoNovo = arquivosPorSlot.some(Boolean);

    function normalizarAnexoExistente(item, indice) {
      if (!item) return null;

      const url = normalizarUrl(item?.url || item?.bancoPrintUrl || "");
      if (!url) return null;

      return {
        url,
        tipo: item?.tipo || item?.bancoPrintTipo || "",
        nome: item?.nome || nomesSlots[indice] || `Anexo ${indice + 1}`,
        tamanho: Number(item?.tamanho || item?.size || 0),
      };
    }

    function descobrirSlotAnexo(item, indicePadrao) {
      const nome = String(item?.nome || "").toLowerCase();

      if (nome.includes("inter")) return 0;
      if (nome.includes("outro")) return 1;

      return indicePadrao;
    }

    const anexosPorSlot = [null, null];
    const anexosExtras = [];

    anexosExistentes.forEach((item, indice) => {
      const normalizado = normalizarAnexoExistente(item, indice);
      if (!normalizado) return;

      const slot = descobrirSlotAnexo(normalizado, indice);

      if (slot === 0 || slot === 1) {
        if (!anexosPorSlot[slot]) {
          anexosPorSlot[slot] = {
            ...normalizado,
            nome: nomesSlots[slot],
          };
          return;
        }
      }

      anexosExtras.push(normalizado);
    });

    if (!possuiArquivoNovo) {
      const combinados = [
        ...anexosPorSlot.filter(Boolean),
        ...anexosExtras,
      ];

      if (combinados.length === 0 && urlBanco) {
        combinados.push({
          url: urlBanco,
          tipo: tipoBanco || "",
          nome: "Banco Inter",
          tamanho: 0,
        });
      }

      const primeiro = combinados[0] || null;

      return {
        bancoPrintUrl: primeiro?.url || "",
        bancoPrintTipo: primeiro?.tipo || "",
        anexosBanco: combinados,
        valorBancoOCR,
      };
    }

    const tokenAtual = getTokenAtual();

    if (!tokenAtual) {
      throw new Error(
        "Sessão expirada. Entre novamente e tente enviar o fechamento."
      );
    }

    arquivosPorSlot.forEach((arquivo) => {
      if (!arquivo) return;

      if (!arquivoPermitidoBanco(arquivo)) {
        throw new Error(
          `Formato inválido em ${arquivo?.name || "um dos arquivos"}. Envie imagem ou PDF do banco.`
        );
      }

      const tamanhoOriginalMb = arquivo.size / (1024 * 1024);

      if (tamanhoOriginalMb > 50) {
        throw new Error(
          `Arquivo muito grande: ${arquivo?.name || "anexo"} (${tamanhoOriginalMb.toFixed(
            1
          )}MB). Envie arquivos de até 50MB cada.`
        );
      }
    });

    setEnviandoBanco(true);

    try {
      let valorOCRPrimeiroArquivo = valorBancoOCR;

      for (let slot = 0; slot < arquivosPorSlot.length; slot += 1) {
        const arquivoOriginal = arquivosPorSlot[slot];
        if (!arquivoOriginal) continue;

        const arquivoOriginalSeguro = prepararArquivoBancoOriginal(arquivoOriginal);
        const arquivoParaEnviar = await prepararArquivoBancoParaEnvio(
          arquivoOriginalSeguro
        );

        // O OCR continua usando somente o primeiro slot (Banco Inter),
        // preservando o comportamento atual sem somar valores de bancos diferentes.
        const deveLerOCRNesteArquivo = slot === 0 && !anexosPorSlot[0];

        const resposta = await enviarArquivoBancoComFallback(
          arquivoParaEnviar,
          tokenAtual,
          { lerOCR: false }
        );

        const bancoPrintTipoFinal =
          resposta.bancoPrintTipo ||
          arquivoParaEnviar.type ||
          arquivoOriginal.type ||
          "application/octet-stream";

        if (
          deveLerOCRNesteArquivo &&
          resposta.valorBancoOCR !== null &&
          resposta.valorBancoOCR !== undefined &&
          Number.isFinite(Number(resposta.valorBancoOCR))
        ) {
          valorOCRPrimeiroArquivo = Number(resposta.valorBancoOCR);
        }

        anexosPorSlot[slot] = {
          url: normalizarUrl(resposta.bancoPrintUrl),
          tipo: bancoPrintTipoFinal,
          nome: nomesSlots[slot],
          tamanho: Number(resposta.size || arquivoOriginal.size || 0),
        };
      }

      const combinados = [
        ...anexosPorSlot.filter(Boolean),
        ...anexosExtras,
      ];

      const primeiro = combinados[0] || null;

      setAnexosBanco(combinados);
      setArquivosBanco([]);
      setArquivoBanco(null);
      setUrlBanco(primeiro?.url || "");
      setTipoBanco(primeiro?.tipo || "");
      setValorBancoOCR(valorOCRPrimeiroArquivo);

      return {
        bancoPrintUrl: primeiro?.url || "",
        bancoPrintTipo: primeiro?.tipo || "",
        anexosBanco: combinados,
        valorBancoOCR: valorOCRPrimeiroArquivo,
      };
    } catch (err) {
      throw new Error(
        err?.message ||
          "Falha ao enviar os prints do banco. Tente novamente com arquivos menores."
      );
    } finally {
      setEnviandoBanco(false);
    }
  }

  async function salvar(e, fecharRelatorio = false) {
    if (e) e.preventDefault();

    if (salvandoRelatorio) return;

    if (faturamento === "") {
      alert("Preencha o faturamento do dia");
      return;
    }

    if (temDevolucaoSemDescricao()) {
      alert("Informe a descrição para Devoluções / estornos");
      return;
    }

    if (temOutroGastoSemDescricao()) {
      alert("Informe a descrição para Outros gastos");
      return;
    }

    try {
      setSalvandoRelatorio(true);

      // Congela os valores INDIVIDUAIS que estão nos inputs antes de fechar.
      // Mesmo que o backend retorne o snapshot consolidado, a parte de baixo
      // precisa continuar mostrando somente o lançamento próprio do usuário.
      const resumoLocalFormulario = montarResumoLocalDoFormulario();

      let relatorioIndividualAntesDoFechamento = {
        data,
        faturamento: resumoLocalFormulario.faturamentoBruto,
        faturamentoBruto: resumoLocalFormulario.faturamentoBruto,
        vendasNovas: resumoLocalFormulario.vendasNovas,
        renovacoes: resumoLocalFormulario.renovacoes,
        leads: resumoLocalFormulario.leads,
        cobradosRenovacao: resumoLocalFormulario.cobradosRenovacao,
        gastoTrafego: resumoLocalFormulario.gastoTrafego,
        creditoServidor: resumoLocalFormulario.creditoServidor,
        devolucoes: resumoLocalFormulario.devolucoes,
        totalDevolucoes: resumoLocalFormulario.totalDevolucoes,
        outrosGastos: resumoLocalFormulario.outrosGastos,
      };

      const snapshotAntesDeSalvar = fecharRelatorio
        ? await buscarSnapshotOperacionalDoDia(me?.email, data)
        : null;

      relatorioIndividualAntesDoFechamento = protegerRelatorioFormulario(
        relatorioIndividualAntesDoFechamento,
        snapshotAntesDeSalvar
      );

      // Proteção extra: a correção de snapshot não pode apagar devoluções digitadas agora.
      if (
        Array.isArray(resumoLocalFormulario.devolucoes) &&
        resumoLocalFormulario.devolucoes.length > 0 &&
        (!Array.isArray(relatorioIndividualAntesDoFechamento.devolucoes) ||
          relatorioIndividualAntesDoFechamento.devolucoes.length === 0)
      ) {
        relatorioIndividualAntesDoFechamento.devolucoes =
          resumoLocalFormulario.devolucoes;
        relatorioIndividualAntesDoFechamento.totalDevolucoes =
          resumoLocalFormulario.totalDevolucoes;
        relatorioIndividualAntesDoFechamento.faturamentoBruto =
          resumoLocalFormulario.faturamentoBruto;
      }

      const colaborador = ehColaboradorUsuario();
      const roleAtual = String(me?.role || "").toLowerCase();
      const podeAnexarBanco = !colaborador;
      const precisaPrintBanco = podeAnexarBanco && roleAtual === "franquia";

      let bancoPrintUrl = podeAnexarBanco ? urlBanco : "";
      let bancoPrintTipo = podeAnexarBanco ? tipoBanco : "";
      let anexosBancoEnvio = podeAnexarBanco
        ? Array.isArray(anexosBanco)
          ? anexosBanco
          : []
        : [];
      let upload = {
        bancoPrintUrl,
        bancoPrintTipo,
        anexosBanco: anexosBancoEnvio,
        valorBancoOCR,
      };

      const possuiArquivoBancoNovo =
        Array.isArray(arquivosBanco) && arquivosBanco.some(Boolean);

      const possuiBancoJaSalvo =
        anexosBancoEnvio.length > 0 || Boolean(bancoPrintUrl);

      if (
        fecharRelatorio &&
        podeAnexarBanco &&
        (precisaPrintBanco || possuiArquivoBancoNovo || possuiBancoJaSalvo)
      ) {
        upload = await uploadPrintBanco();
        bancoPrintUrl = upload?.bancoPrintUrl || "";
        bancoPrintTipo = upload?.bancoPrintTipo || "";
        anexosBancoEnvio = Array.isArray(upload?.anexosBanco)
          ? upload.anexosBanco
          : [];
      }

      if (
        fecharRelatorio &&
        precisaPrintBanco &&
        !bancoPrintUrl &&
        anexosBancoEnvio.length === 0
      ) {
        alert("Para fechar o relatório do dia, anexe pelo menos 1 print do banco.");
        return;
      }

      const res = await fetch(`${API_BASE}/relatorio-diario`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getTokenAtual(),
        },
        body: JSON.stringify({
          data,
          faturamento: Number(
            relatorioIndividualAntesDoFechamento.faturamentoBruto ||
              relatorioIndividualAntesDoFechamento.faturamento ||
              0
          ),
          faturamentoBruto: Number(
            relatorioIndividualAntesDoFechamento.faturamentoBruto ||
              relatorioIndividualAntesDoFechamento.faturamento ||
              0
          ),
          vendasNovas: Number(relatorioIndividualAntesDoFechamento.vendasNovas || 0),
          renovacoes: Number(relatorioIndividualAntesDoFechamento.renovacoes || 0),
          leads: Number(relatorioIndividualAntesDoFechamento.leads || 0),
          cobradosRenovacao: Number(relatorioIndividualAntesDoFechamento.cobradosRenovacao || 0),
          gastoTrafego: Number(relatorioIndividualAntesDoFechamento.gastoTrafego || 0),
          creditoServidor: Number(relatorioIndividualAntesDoFechamento.creditoServidor || 0),
          devolucoes:
            relatorioIndividualAntesDoFechamento.devolucoes ||
            resumoLocalFormulario.devolucoes ||
            [],
          totalDevolucoes: Number(
            relatorioIndividualAntesDoFechamento.totalDevolucoes ??
              resumoLocalFormulario.totalDevolucoes ??
              0
          ),
          outrosGastos: relatorioIndividualAntesDoFechamento.outrosGastos || [],
          bancoPrintUrl,
          bancoPrintTipo,
          anexosBanco: anexosBancoEnvio,
          valorBancoOCR:
            upload?.valorBancoOCR === null || upload?.valorBancoOCR === undefined
              ? valorBancoOCR
              : Number(upload.valorBancoOCR),
          fecharRelatorio,
        }),
      });

      const resposta = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(resposta)) return;

      if (!res.ok) {
        if (resposta?.codigo === "DIVERGENCIA_OCR_FECHAMENTO" && resposta?.popup) {
          alert(
            `${resposta.popup.titulo}\n\n` +
              `Valor lançado:\n${resposta.popup.valorLancado}\n\n` +
              `Valor encontrado no banco:\n${resposta.popup.valorBancoOCR}\n\n` +
              `Diferença:\n${resposta.popup.diferenca}\n\n` +
              `${resposta.popup.mensagem}`
          );
          return;
        }

        throw new Error(resposta?.error || "Erro ao salvar relatório.");
      }

      if (res.ok) {
        alert(
          fecharRelatorio
            ? resposta.message || "Relatório fechado ✅"
            : "Relatório atualizado sem enviar para aprovação ✅"
        );
        const usuarioAtualizado = me || (await carregarMe());

        // Mantém os cards atualizados imediatamente com o que acabou de ser enviado.
        // Isso evita que o fallback /minha-rede (que ainda não conhece devoluções)
        // volte Devoluções = 0 após clicar em Atualizar relatório.
        // Mantém devoluções atualizadas sem apagar colaboradores dos cards.
const resumoLocalPosSalvar = montarResumoLocalDoFormulario();

setResumoOperacaoHoje((atual) => {
  if (!atual) return atual;

  const devolucaoAnterior = Number(atual.totalDevolucoes || 0);
  const devolucaoNova = Number(
    resumoLocalPosSalvar.totalDevolucoes || 0
  );

  const diferencaDevolucao = devolucaoNova - devolucaoAnterior;

  return {
    ...atual,

    totalDevolucoes: devolucaoNova,

    faturamento:
      Number(atual.faturamento || 0) - diferencaDevolucao,

    lucroLiquido:
      Number(atual.lucroLiquido || 0) - diferencaDevolucao,

    lucroRealEmpresa:
      Number(atual.lucroRealEmpresa || 0) - diferencaDevolucao,
  };
});

        // Ao fechar, o backend retorna dois objetos:
        // - relatorio: snapshot consolidado para aprovação
        // - relatorioProprio: base individual editável
        // A tela de Lançamentos NUNCA pode preencher os inputs com o snapshot,
        // senão o valor do colaborador entra no formulário e duplica no reenvio.
        if (fecharRelatorio) {
          const relatorioSeguroParaFormulario = protegerRelatorioFormulario(
            {
              ...(resposta.relatorioProprio || {}),
              ...relatorioIndividualAntesDoFechamento,
              bancoPrintUrl,
              bancoPrintTipo,
              anexosBanco: anexosBancoEnvio,
              fechado: true,
              fechamentoOperacional: false,
              incluiColaboradores: false,
              colaboradoresIncluidos: [],
              statusAprovacao:
                resposta.relatorio?.statusAprovacao ||
                resposta.relatorioProprio?.statusAprovacao ||
                "pendente",
              statusHistoricoAprovacao:
                resposta.relatorio?.statusHistoricoAprovacao ||
                resposta.relatorio?.statusAprovacao ||
                "",
              valorOcrBanco:
                resposta.relatorio?.valorOcrBanco ??
                resposta.relatorioProprio?.valorOcrBanco ??
                valorBancoOCR,
            },
            resposta.relatorio || snapshotAntesDeSalvar
          );

          preencherFormularioComRelatorio(
            relatorioSeguroParaFormulario,
            resposta.relatorio?.statusAprovacao === "aprovado_automaticamente"
              ? "Fechado • Aprovado automaticamente"
              : "Fechado • Aguardando aprovação"
          );
        } else {
          preencherFormularioComRelatorio(
            {
              ...(resposta.relatorio || {}),
              ...resumoLocalPosSalvar,
              data,
              gastoTrafego: resumoLocalPosSalvar.gastoTrafego,
              creditoServidor: resumoLocalPosSalvar.creditoServidor,
              outrosGastos: resumoLocalPosSalvar.outrosGastos,
              devolucoes: resumoLocalPosSalvar.devolucoes,
              bancoPrintUrl,
              bancoPrintTipo,
              anexosBanco: anexosBancoEnvio,
              fechado: false,
              fechamentoOperacional: false,
              incluiColaboradores: false,
              colaboradoresIncluidos: [],
            },
            "Rascunho / atualização parcial"
          );
        }

        await carregarRelatorios(usuarioAtualizado);

        
      } else {
        alert(resposta.error || "Erro ao salvar relatório");
      }
    } catch (err) {
      console.log(err);
      alert(err.message || "Erro ao salvar relatório");
    } finally {
      setSalvandoRelatorio(false);
    }
  }


  async function lerPrintBanco(e, slot = 0) {
    const arquivo = e.target.files?.[0] || null;
    e.target.value = "";

    if (!arquivo) return;

    if (!arquivoPermitidoBanco(arquivo)) {
      alert(
        `Formato inválido em ${arquivo.name}. Envie imagem ou PDF do banco.`
      );
      return;
    }

    const tamanhoMb = arquivo.size / (1024 * 1024);

    if (tamanhoMb > 50) {
      alert(
        `Arquivo acima de 50MB: ${arquivo.name}.`
      );
      return;
    }

    const slotSeguro = slot === 1 ? 1 : 0;

    setArquivosBanco((atuais) => {
      const novos = [
        Array.isArray(atuais) ? atuais[0] || null : null,
        Array.isArray(atuais) ? atuais[1] || null : null,
      ];

      novos[slotSeguro] = arquivo;
      return novos;
    });

    if (slotSeguro === 0 || !arquivoBanco) {
      setArquivoBanco(arquivo);
    }

    alert(
      slotSeguro === 0
        ? "Print do Banco Inter selecionado. Ele será enviado no fechamento do dia."
        : "Print do Outro banco selecionado. Ele será enviado no fechamento do dia."
    );
  }

  async function lerComprovante(e) {
    const arquivo = e.target.files[0];
    e.target.value = "";

    if (!arquivo) return;

    const formData = new FormData();
    formData.append("comprovante", arquivo);

    setLendoComprovante(true);

    try {
      const res = await fetch(`${API_BASE}/ler-comprovante`, {
        method: "POST",
        headers: {
          Authorization: getTokenAtual(),
        },
        body: formData,
      });

      const resposta = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(resposta)) return;

      if (!res.ok) {
        alert(resposta.error || "Erro ao ler comprovante");
        return;
      }

      const valorLido = Number(resposta.valor || 0);

      setPopupComprovante({
        valor: valorLido > 0 ? formatarNumeroComoMoeda(valorLido) : "",
        valorOriginal: valorLido,
        comprovanteHash: resposta.comprovanteHash,
        textoExtraido: resposta.textoExtraido || "",
        arquivoUrl: resposta.arquivoUrl || "",
        tipoArquivo: resposta.tipoArquivo || "",
      });

      setTipoComprovante("vendaNova");
    } catch (err) {
      alert(err?.message || "Erro ao enviar comprovante");
    } finally {
      setLendoComprovante(false);
    }
  }

  async function lancarValorManual() {
    if (salvandoManual) return;

    const valor = converterMoedaParaNumero(valorManual);

    if (valor <= 0) {
      alert("Informe um valor válido");
      return;
    }

    setSalvandoManual(true);

    try {
      const novoFaturamento = faturamentoNumero + valor;

      const novasVendas =
        tipoManual === "vendaNova"
          ? Number(vendasNovas || 0) + 1
          : Number(vendasNovas || 0);

      const novasRenovacoes =
        tipoManual === "renovacao"
          ? Number(renovacoes || 0) + 1
          : Number(renovacoes || 0);

      const itemHistoricoManual = {
        id: `manual-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        origem: "manual",
        tipo: tipoManual,
        valor,
        descricao:
          tipoManual === "vendaNova"
            ? "Lançamento manual — venda nova"
            : "Lançamento manual — renovação",
        criadoEm: new Date().toISOString(),
      };

      const res = await fetch(`${API_BASE}/relatorio-diario`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getTokenAtual(),
        },
        body: JSON.stringify({
          data,
          faturamento: novoFaturamento,
          vendasNovas: novasVendas,
          renovacoes: novasRenovacoes,
          leads: Number(leads || 0),
          gastoTrafego: converterMoedaParaNumero(gastoTrafego),
          creditoServidor: converterMoedaParaNumero(creditoServidor),
          devolucoes: montarDevolucoesFormatadas(),
          outrosGastos: montarOutrosGastosFormatados(),
          fecharRelatorio: false,
          historicoLancamento: itemHistoricoManual,
        }),
      });

      const resposta = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(resposta)) return;

      if (res.ok) {
        const relatorioRespondido = resposta?.relatorio || null;

        alert("Valor lançado manualmente 🚀");
        setValorManual("");

        if (relatorioRespondido) {
          setRelatorioAtual(protegerRelatorioFormulario(relatorioRespondido));
        } else {
          setRelatorioAtual((atual) => ({
            ...(atual || {}),
            historicoLancamentos: [
              itemHistoricoManual,
              ...(Array.isArray(atual?.historicoLancamentos)
                ? atual.historicoLancamentos
                : []),
            ],
          }));
        }

        const usuarioAtualizado = me || (await carregarMe());

        // Recarrega o extrato depois de uma pequena pausa para garantir
        // que o Mongo já gravou o lançamento paralelo.
        await aguardar(300);
        await carregarExtratoDoDia();
        await carregarRelatorioDoDia();
        await carregarRelatorios(usuarioAtualizado);
      } else {
        alert(resposta.error || "Erro ao lançar valor");
      }
    } catch (err) {
      alert(err?.message || "Erro ao lançar valor");
    } finally {
      setSalvandoManual(false);
    }
  }

  async function confirmarComprovante() {
    if (confirmandoComprovante) return;
    if (!popupComprovante) return;

    const valorDetectado = converterMoedaParaNumero(popupComprovante.valor);

    if (valorDetectado <= 0) {
      alert("Informe um valor válido");
      return;
    }

    if (!popupComprovante.comprovanteHash) {
      alert("Comprovante sem identificação. Envie novamente.");
      return;
    }

    setConfirmandoComprovante(true);

    try {
      const res = await fetch(`${API_BASE}/confirmar-comprovante`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getTokenAtual(),
        },
        body: JSON.stringify({
          data,
          valor: valorDetectado,
          tipo: tipoComprovante,
          comprovanteHash: popupComprovante.comprovanteHash,
          arquivoUrl: popupComprovante.arquivoUrl || "",
          tipoArquivo: popupComprovante.tipoArquivo || "",
        }),
      });

      const resposta = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(resposta)) return;

      if (res.ok) {
        alert("Comprovante lançado com sucesso 🚀");
        setPopupComprovante(null);
        const usuarioAtualizado = me || (await carregarMe());

        // Recarrega o extrato depois de uma pequena pausa para garantir
        // que o Mongo já gravou o lançamento paralelo.
        await aguardar(300);
        await carregarExtratoDoDia();
        await carregarRelatorioDoDia();
        await carregarRelatorios(usuarioAtualizado);
      } else {
        alert(resposta.error || "Erro ao lançar comprovante");
      }
    } catch (err) {
      alert(err?.message || "Erro ao confirmar comprovante");
    } finally {
      setConfirmandoComprovante(false);
    }
  }


  async function excluirLancamentoExtrato(item) {
    if (!item) return;

    const idLancamento = item._id || item.idLancamento || item.id;

    if (!idLancamento) {
      alert("Não consegui identificar este lançamento para excluir.");
      return;
    }

    const confirmar = window.confirm(
      "Tem certeza que deseja excluir este lançamento?\n\nEssa ação remove do extrato e desconta o valor dos totais do dia."
    );

    if (!confirmar) return;

    try {
      const res = await fetch(
        `${API_BASE}/extrato-lancamentos-dia/${idLancamento}`,
        {
          method: "DELETE",
          headers: {
            Authorization: getTokenAtual(),
          },
        }
      );

      const resposta = await res.json();

      if (!res.ok && tratarRespostaTokenInvalido(resposta)) return;

      if (!res.ok) {
        alert(resposta.error || "Erro ao excluir lançamento.");
        return;
      }

      alert("Lançamento excluído com sucesso ✅");

      const usuarioAtualizado = me || (await carregarMe());

      await carregarExtratoDoDia();
      await carregarRelatorioDoDia();
      await carregarRelatorios(usuarioAtualizado);
    } catch (err) {
      console.log(err);
      alert(err?.message || "Erro ao excluir lançamento.");
    }
  }


  function traduzirStatus(status) {
    const mapa = {
      pendente: "Aguardando aprovação",
      aprovado: "Aprovado",
      aprovado_automaticamente: "Aprovado automaticamente",
      rejeitado: "Rejeitado",
      aguardando_correcao: "Aguardando correção",
    };

    return mapa[status] || status || "Rascunho";
  }

  function statusVisivelDoRelatorio(relatorio) {
    if (!relatorio) return "";

    const statusAtivo = relatorio.statusAprovacao || "";
    const statusHistorico = relatorio.statusHistoricoAprovacao || "";

    if (statusAtivo === "rejeitado" || statusAtivo === "aguardando_correcao") {
      return statusAtivo;
    }

    if (
      statusHistorico === "aprovado" ||
      statusHistorico === "aprovado_automaticamente" ||
      statusHistorico === "rejeitado" ||
      statusHistorico === "aguardando_correcao"
    ) {
      return statusHistorico;
    }

    return statusAtivo;
  }

  function observacaoVisivelDoRelatorio(relatorio) {
    if (!relatorio) return "";

    return (
      relatorio.observacaoAprovacao ||
      relatorio.observacaoHistoricoAprovacao ||
      ""
    );
  }

  function textoStatusDoDia(relatorio) {
    if (!relatorio) return "Ainda não iniciado";

    const statusVisivel = statusVisivelDoRelatorio(relatorio);

    if (relatorio.fechado) {
      return `Fechado • ${traduzirStatus(statusVisivel || relatorio.statusAprovacao)}`;
    }

    if (
      (statusVisivel === "aprovado" || statusVisivel === "aprovado_automaticamente") &&
      (relatorio.statusHistoricoAprovacao === "aprovado" ||
        relatorio.statusHistoricoAprovacao === "aprovado_automaticamente")
    ) {
      return statusVisivel === "aprovado_automaticamente"
        ? "Aprovado automaticamente"
        : "Aprovado";
    }

    if (statusVisivel === "rejeitado" || statusVisivel === "aguardando_correcao") {
      return traduzirStatus(statusVisivel);
    }

    return "Rascunho / atualização parcial";
  }

  useEffect(() => {
    const tokenAtual = getTokenAtual();

    if (!tokenAtual) {
      limparSessaoTokenInvalido();
      window.location.href = "/login";
      return;
    }

    async function iniciar() {
      const usuario = await carregarMe();
      await carregarConfiguracoesRoyalties();
      await carregarRelatorioDoDia();
      await carregarRelatorios(usuario);
    }

    iniciar();
  }, [data]);

  function calcularRoyaltiesResumo(resumo) {
    if (ehColaboradorUsuario()) return 0;
    if (!royaltiesConfig?.ativo) return 0;

    const percentual = Number(royaltiesConfig.percentual || 0);
    if (!percentual) return 0;

    const base =
      royaltiesConfig.tipo === "bruto"
        ? Number(resumo?.faturamento || 0)
        : Number(resumo?.lucroLiquido || 0);

    return Math.max(0, base) * (percentual / 100);
  }

  function calcularMeuLucroResumo(resumo) {
    return (
      Number(resumo?.lucroLiquido || 0) -
      calcularRoyaltiesResumo(resumo) -
      Number(resumo?.creditoServidor || 0)
    );
  }

  const faturamentoBrutoNumero = converterMoedaParaNumero(faturamento);
  const totalDevolucoes = devolucoes.reduce(
    (acc, item) => acc + converterMoedaParaNumero(item.valor),
    0
  );
  const faturamentoNumero = Math.max(0, faturamentoBrutoNumero - totalDevolucoes);
  const gastoTrafegoNumero = converterMoedaParaNumero(gastoTrafego);
  const creditoServidorNumero = converterMoedaParaNumero(creditoServidor);
  const totalOutrosGastos = outrosGastos.reduce(
    (acc, gasto) => acc + converterMoedaParaNumero(gasto.valor),
    0
  );

  const totalGastos = gastoTrafegoNumero + totalOutrosGastos;
  const lucroLiquido = faturamentoNumero - totalGastos;
  const lucroRealEmpresa = lucroLiquido - creditoServidorNumero;

  const resumoCards = resumoOperacaoHoje || {
    faturamento: faturamentoNumero,
    faturamentoBruto: faturamentoBrutoNumero,
    totalDevolucoes,
    gastoTrafego: gastoTrafegoNumero,
    totalOutrosGastos,
    totalGastos,
    lucroLiquido,
    creditoServidor: creditoServidorNumero,
    lucroRealEmpresa,
    vendasNovas: Number(vendasNovas || 0),
    renovacoes: Number(renovacoes || 0),
    leads: Number(leads || 0),
    cobradosRenovacao: Number(cobradosRenovacao || 0),
  };

  function calcularTaxaRenovacao(resumo) {
    const cobrados = Number(resumo?.cobradosRenovacao || 0);
    const totalRenovacoes = Number(resumo?.renovacoes || 0);

    return cobrados > 0 ? (totalRenovacoes / cobrados) * 100 : 0;
  }

  function calcularTaxaConversao(resumo) {
    const totalLeads = Number(resumo?.leads || 0);
    const totalVendasNovas = Number(resumo?.vendasNovas || 0);

    return totalLeads > 0 ? (totalVendasNovas / totalLeads) * 100 : 0;
  }

  function formatarPercentual(valor) {
    return `${Number(valor || 0).toLocaleString("pt-BR", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    })}%`;
  }

  const extratoDoDia = Array.isArray(extratoDia)
    ? [...extratoDia].sort((a, b) => {
        const dataA = new Date(a?.criadoEm || a?.createdAt || 0).getTime();
        const dataB = new Date(b?.criadoEm || b?.createdAt || 0).getTime();
        return dataB - dataA;
      })
    : [];

  const dataSelecionadaEhHoje = data === hoje;
  const sufixoCards = dataSelecionadaEhHoje ? "hoje" : "do dia";

  return (
    <div style={container}>
      <style>{`
        @keyframes pulseFecharRelatorio {
          0% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.65);
          }

          70% {
            transform: scale(1.035);
            box-shadow: 0 0 0 16px rgba(34, 197, 94, 0);
          }

          100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
          }
        }
      `}</style>

      <h1>📊 Relatório Diário</h1>

      <div style={acoesTopo}>
        <label style={botaoUpload}>
          {lendoComprovante ? "🔎 Lendo comprovante..." : "📤 Receber comprovante"}
          <input
            type="file"
            accept="image/*,application/pdf"
            style={{ display: "none" }}
            onChange={lerComprovante}
            disabled={lendoComprovante}
          />
        </label>
      </div>

      <div style={cards}>
        <Card titulo={`Faturamento válido ${sufixoCards}`} valor={formatarValor(resumoCards.faturamento)} />
        <Card titulo={`Entrada bruta ${sufixoCards}`} valor={formatarValor(resumoCards.faturamentoBruto ?? resumoCards.faturamento)} />
        <Card titulo={`Devoluções ${sufixoCards}`} valor={formatarValor(resumoCards.totalDevolucoes || 0)} />
        <Card titulo={`Tráfego pago ${sufixoCards}`} valor={formatarValor(resumoCards.gastoTrafego)} />
        <Card titulo={`Outros gastos ${sufixoCards}`} valor={formatarValor(resumoCards.totalOutrosGastos)} />
        <Card titulo={`Total de gastos ${sufixoCards}`} valor={formatarValor(resumoCards.totalGastos)} />
        <Card titulo={`Lucro líquido ${sufixoCards}`} valor={formatarValor(resumoCards.lucroLiquido)} />
        <Card titulo={`Créditos servidor ${sufixoCards}`} valor={formatarValor(resumoCards.creditoServidor)} />
        <Card titulo={`Meu lucro ${sufixoCards}`} valor={formatarValor(calcularMeuLucroResumo(resumoCards))} />
        <Card titulo={`Vendas novas ${sufixoCards}`} valor={Number(resumoCards.vendasNovas || 0)} />
        <Card titulo={`Renovações ${sufixoCards}`} valor={Number(resumoCards.renovacoes || 0)} />
        <Card titulo={`Leads ${sufixoCards}`} valor={Number(resumoCards.leads || 0)} />
        <Card
          titulo={`Taxa de renovação ${sufixoCards}`}
          valor={formatarPercentual(calcularTaxaRenovacao(resumoCards))}
        />
        <Card
          titulo={`Conversão dos leads ${sufixoCards}`}
          valor={formatarPercentual(calcularTaxaConversao(resumoCards))}
        />
      </div>

      {me?.role !== "colaborador" && (
        <div style={aviso}>
          👁️ Os cards acima mostram seu resultado {dataSelecionadaEhHoje ? "de hoje" : "da data selecionada"} somando colaboradores diretos.
        </div>
      )}

      {me?.role === "colaborador" && (
        <div style={aviso}>
          👁️ Os cards acima mostram somente o seu lançamento individual {dataSelecionadaEhHoje ? "de hoje" : "da data selecionada"}.
        </div>
      )}

      <div style={box}>
        <h2>📝 Lançamento do dia</h2>

        <div style={statusBox}>
          <strong>Status do dia:</strong> {statusRelatorio || "Carregando..."}

          {statusVisivelDoRelatorio(relatorioAtual) === "rejeitado" && (
            <div style={alertaRejeitado}>
              ❌ Seu relatório foi rejeitado. Corrija os dados e feche novamente.
              {observacaoVisivelDoRelatorio(relatorioAtual) && (
                <p style={alertaTexto}>
                  Motivo: {observacaoVisivelDoRelatorio(relatorioAtual)}
                </p>
              )}
            </div>
          )}

          {statusVisivelDoRelatorio(relatorioAtual) === "aguardando_correcao" && (
            <div style={alertaCorrecao}>
              🔵 Correção solicitada pelo gestor. Atualize e feche novamente.
              {observacaoVisivelDoRelatorio(relatorioAtual) && (
                <p style={alertaTexto}>
                  Observação: {observacaoVisivelDoRelatorio(relatorioAtual)}
                </p>
              )}
            </div>
          )}

          {statusVisivelDoRelatorio(relatorioAtual) === "aprovado" &&
            relatorioAtual?.statusHistoricoAprovacao === "aprovado" && (
              <div style={alertaAprovado}>
                ✅ Seu relatório foi aprovado.
              </div>
            )}
        </div>

        <form onSubmit={(e) => salvar(e, false)}>
          <div style={gridForm}>
            <Input label="Data" type="date" value={data} onChange={setData} />

            <Input
              label="Faturamento"
              value={faturamento}
              onChange={(valor) => setFaturamento(formatarMoeda(valor))}
            />

            <Input
              label="Vendas novas"
              type="number"
              value={vendasNovas}
              onChange={setVendasNovas}
            />

            <Input
              label="Renovações"
              type="number"
              value={renovacoes}
              onChange={setRenovacoes}
            />

            <Input
              label="Leads"
              type="number"
              value={leads}
              onChange={setLeads}
            />

            <Input
              label="Clientes cobrados para renovar"
              type="number"
              value={cobradosRenovacao}
              onChange={setCobradosRenovacao}
            />
          </div>

          <div style={boxInterno}>
            <h3>➕ Lançamento rápido manual</h3>

            <div style={gridForm}>
              <div>
                <strong>Valor</strong>
                <input
                  style={{ ...input, width: "100%", marginTop: 6 }}
                  placeholder="R$ 0,00"
                  value={valorManual}
                  onChange={(e) => setValorManual(formatarMoeda(e.target.value))}
                />
              </div>

              <div>
                <strong>Tipo</strong>
                <select
                  style={{ ...input, width: "100%", marginTop: 6 }}
                  value={tipoManual}
                  onChange={(e) => setTipoManual(e.target.value)}
                >
                  <option value="vendaNova">Venda nova</option>
                  <option value="renovacao">Renovação</option>
                </select>
              </div>
            </div>

            <button
              type="button"
              style={{
                ...botaoPrincipal,
                marginTop: 16,
                opacity: salvandoManual ? 0.6 : 1,
                cursor: salvandoManual ? "not-allowed" : "pointer",
              }}
              onClick={lancarValorManual}
              disabled={salvandoManual}
            >
              {salvandoManual ? "Lançando..." : "Somar ao faturamento"}
            </button>
          </div>

          <div style={boxInterno}>
            <h3>📢 Gastos com tráfego pago</h3>

            <Input
              label="Gastos com tráfego pago"
              value={gastoTrafego}
              onChange={(valor) => setGastoTrafego(formatarMoeda(valor))}
            />
          </div>

          <div style={boxInterno}>
            <h3>💳 Créditos do servidor</h3>
            <p style={{ marginTop: 0, color: "#64748b" }}>
              Opcional. Preencha somente no dia em que comprar créditos.
              Esse valor entra no histórico financeiro, mas não altera royalties nem o lucro líquido operacional.
            </p>

            <Input
              label="Créditos do servidor"
              value={creditoServidor}
              onChange={(valor) => setCreditoServidor(formatarMoeda(valor))}
            />
          </div>

          <div style={boxInterno}>
            <h3>🔁 Devoluções / estornos</h3>
            <p style={{ marginTop: 0, color: "#64748b" }}>
              Use quando entrou um valor no banco, mas parte dele foi devolvida.
              Esse valor abate o faturamento antes dos royalties.
            </p>

            {devolucoes.map((item, index) => (
              <div key={index} style={gastoLinha}>
                <input
                  style={input}
                  placeholder="Ex: PIX devolvido, pagamento duplicado"
                  value={item.descricao}
                  onChange={(e) =>
                    atualizarDevolucao(index, "descricao", e.target.value)
                  }
                />

                <input
                  style={input}
                  placeholder="Valor devolvido"
                  value={item.valor}
                  onChange={(e) =>
                    atualizarDevolucao(index, "valor", e.target.value)
                  }
                />

                <input
                  type="file"
                  accept="image/*,.pdf"
                  onChange={(e) =>
                    uploadComprovanteDevolucao(index, e.target.files[0])
                  }
                />

                {(item.comprovanteUrl || item.arquivoUrl) && (
                  <a
                    href={normalizarUrl(item.comprovanteUrl || item.arquivoUrl)}
                    target="_blank"
                    rel="noreferrer"
                    style={linkAnexo}
                  >
                    Abrir comprovante
                  </a>
                )}

                <button
                  type="button"
                  style={botaoRemover}
                  onClick={() => removerDevolucao(index)}
                >
                  Remover
                </button>
              </div>
            ))}

            <button
              type="button"
              style={botaoSecundario}
              onClick={adicionarDevolucao}
            >
              + Adicionar devolução
            </button>
          </div>

          <div style={boxInterno}>
            <h3>💸 Outros gastos</h3>

            {outrosGastos.map((gasto, index) => (
              <div key={index} style={gastoLinha}>
                <input
                  style={input}
                  placeholder="Descrição obrigatória"
                  value={gasto.descricao}
                  onChange={(e) =>
                    atualizarOutroGasto(index, "descricao", e.target.value)
                  }
                />

                <input
                  style={input}
                  placeholder="Valor"
                  value={gasto.valor}
                  onChange={(e) =>
                    atualizarOutroGasto(index, "valor", e.target.value)
                  }
                />

                <input
                  type="file"
                  accept="image/*,.pdf"
                  onChange={(e) =>
                    uploadComprovanteOutroGasto(index, e.target.files[0])
                  }
                />

                {(gasto.comprovanteUrl || gasto.arquivoUrl) && (
                  <a
                    href={normalizarUrl(gasto.comprovanteUrl || gasto.arquivoUrl)}
                    target="_blank"
                    rel="noreferrer"
                    style={linkAnexo}
                  >
                    Abrir comprovante
                  </a>
                )}

                <button
                  type="button"
                  style={botaoRemover}
                  onClick={() => removerOutroGasto(index)}
                >
                  Remover
                </button>
              </div>
            ))}

            <button
              type="button"
              style={botaoSecundario}
              onClick={adicionarOutroGasto}
            >
              + Adicionar outro gasto
            </button>
          </div>

          <div style={boxInterno}>
            <h3>🏦 Fechamento bancário do dia</h3>

            <p style={{ marginTop: 0, color: "#64748b" }}>
              {ehColaboradorUsuario()
                ? "Colaborador pode fechar sem print do banco, pois o valor cai na conta da franquia responsável."
                : String(me?.role || "").toLowerCase() === "franquia"
                ? <>A franquia deve anexar pelo menos <strong>1 print</strong> para fechar o relatório. Use Banco Inter e, se houver movimentação em outro banco, use o segundo campo.</>
                : "Gestor/Master pode anexar os prints abaixo para conferência, mas eles são opcionais."}
            </p>

            {!ehColaboradorUsuario() && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    border: "1px solid #dbe4ee",
                    borderRadius: 12,
                    padding: 12,
                    background: "#f8fafc",
                  }}
                >
                  <strong style={{ display: "block", marginBottom: 8 }}>
                    🏦 Banco Inter
                  </strong>

                  <label style={botaoBanco}>
                    {enviandoBanco
                      ? "Enviando..."
                      : arquivosBanco?.[0]
                      ? `📎 ${arquivosBanco[0].name}`
                      : anexoBancoSalvoPorSlot(0)?.url
                      ? "✅ Print Banco Inter anexado"
                      : "📤 Anexar print Banco Inter"}
                    <input
                      type="file"
                      accept="image/*,application/pdf,.heic,.heif"
                      style={{ display: "none" }}
                      onChange={(e) => lerPrintBanco(e, 0)}
                      disabled={enviandoBanco}
                    />
                  </label>

                  {anexoBancoSalvoPorSlot(0)?.url && (
                    <a
                      href={anexoBancoSalvoPorSlot(0).url}
                      target="_blank"
                      rel="noreferrer"
                      style={{ ...linkAnexo, display: "inline-block", marginTop: 8 }}
                    >
                      Abrir print Banco Inter
                    </a>
                  )}
                </div>

                <div
                  style={{
                    border: "1px solid #dbe4ee",
                    borderRadius: 12,
                    padding: 12,
                    background: "#f8fafc",
                  }}
                >
                  <strong style={{ display: "block", marginBottom: 8 }}>
                    🏦 Outro banco
                  </strong>

                  <label style={botaoBanco}>
                    {enviandoBanco
                      ? "Enviando..."
                      : arquivosBanco?.[1]
                      ? `📎 ${arquivosBanco[1].name}`
                      : anexoBancoSalvoPorSlot(1)?.url
                      ? "✅ Print Outro banco anexado"
                      : "📤 Anexar print Outro banco"}
                    <input
                      type="file"
                      accept="image/*,application/pdf,.heic,.heif"
                      style={{ display: "none" }}
                      onChange={(e) => lerPrintBanco(e, 1)}
                      disabled={enviandoBanco}
                    />
                  </label>

                  {anexoBancoSalvoPorSlot(1)?.url && (
                    <a
                      href={anexoBancoSalvoPorSlot(1).url}
                      target="_blank"
                      rel="noreferrer"
                      style={{ ...linkAnexo, display: "inline-block", marginTop: 8 }}
                    >
                      Abrir print Outro banco
                    </a>
                  )}
                </div>
              </div>
            )}
          </div>

          <br />

          <div style={botoesFechamento}>
            <button
              type="submit"
              style={{
                ...botaoAtualizar,
                opacity: salvandoRelatorio ? 0.6 : 1,
              }}
              disabled={salvandoRelatorio}
            >
              {salvandoRelatorio ? "Salvando..." : "Atualizar relatório"}
            </button>

            <button
              type="button"
              style={{
                ...botaoFecharRelatorio,
                opacity: salvandoRelatorio ? 0.6 : 1,
              }}
              onClick={(e) => salvar(e, true)}
              disabled={salvandoRelatorio}
            >
              {salvandoRelatorio ? "Fechando..." : "✅ FINALIZAR E ENVIAR RELATÓRIO DIÁRIO"}
            </button>
          </div>
        </form>
      </div>
<div style={boxExtrato}>
        <div style={extratoTopo}>
          <h2 style={extratoTitulo}>🧾 Extrato do dia</h2>
        </div>

        {extratoDoDia.length === 0 ? (
          <div style={extratoVazio}>
            Nenhum lançamento individual registrado ainda.
          </div>
        ) : (
          <div style={extratoLista}>
            {extratoDoDia.map((item, index) => (
              <div key={item.id || `${item.origem}-${item.criadoEm}-${index}`} style={extratoLinha}>
                <div style={extratoLinhaEsquerda}>
                  <strong>
                    {item.origem === "ocr" ? "📤 OCR comprovante" : "✍️ Manual"}
                  </strong>
                  <span style={extratoMeta}>
                    {item.tipo === "renovacao" ? "Renovação" : "Venda nova"}
                    {" • "}
                    {(item.criadoEm || item.createdAt)
                      ? new Date(item.criadoEm || item.createdAt).toLocaleTimeString("pt-BR", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                      : "Horário não informado"}
                  </span>
                  {item.descricao && <small style={extratoDescricao}>{item.descricao}</small>}
                </div>

                <div style={extratoLinhaDireita}>
                  <strong>{formatarValor(item.valor)}</strong>
                  {item.arquivoUrl && (
                    <a
                      href={normalizarUrl(item.arquivoUrl)}
                      target="_blank"
                      rel="noreferrer"
                      style={extratoAnexo}
                    >
                      Abrir anexo
                    </a>
                  )}

                  <button
                    type="button"
                    style={botaoExcluirExtrato}
                    onClick={() => excluirLancamentoExtrato(item)}
                  >
                    Excluir
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div style={box}>
        <h2>📅 Histórico dos lançamentos</h2>

        {relatorios.map((item) => (
          <div key={item._id} style={linha}>
            <div>
              <strong>{item.data}</strong>
              <p style={{ margin: 0, color: "#334155", fontWeight: "bold" }}>
                {item.nomeEmpresa || item.usuario}
              </p>
              <p style={{ margin: 0, color: "#666" }}>
                Vendas: {item.totalVendas} | Leads: {item.leads}
              </p>
              <p style={{ margin: 0, color: "#666" }}>
                Tráfego: {formatarValor(item.gastoTrafego || 0)} | Outros:{" "}
                {formatarValor(item.totalOutrosGastos || 0)} | Créditos:{" "}
                {formatarValor(item.creditoServidor || 0)}
              </p>
              <p style={{ margin: 0, color: "#475569" }}>
                Status:{" "}
                {item.statusHistoricoAprovacao
                  ? traduzirStatus(item.statusHistoricoAprovacao)
                  : item.fechado
                  ? traduzirStatus(item.statusAprovacao)
                  : item.statusAprovacao === "rejeitado" ||
                    item.statusAprovacao === "aguardando_correcao"
                  ? traduzirStatus(item.statusAprovacao)
                  : "Rascunho / parcial"}
              </p>
              {(item.observacaoHistoricoAprovacao || item.observacaoAprovacao) && (
                <p
                  style={{
                    margin: "6px 0 0",
                    color: "#991b1b",
                    fontWeight: "bold",
                  }}
                >
                  Obs: {item.observacaoHistoricoAprovacao || item.observacaoAprovacao}
                </p>
              )}
            </div>

            <div style={{ textAlign: "right" }}>
              <strong>Faturamento: {formatarValor(item.faturamento || 0)}</strong>
              <p style={{ margin: 0, color: "#991b1b" }}>
                Gastos: {formatarValor(item.totalGastos || 0)}
              </p>
              <p style={{ margin: 0, color: "#16a34a" }}>
                Lucro: {formatarValor(item.lucroLiquido || 0)}
              </p>
              <p style={{ margin: 0, color: "#0f766e" }}>
                Meu lucro: {formatarValor(
                  calcularMeuLucroResumo(item)
                )}
              </p>
            </div>
          </div>
        ))}
      </div>

      {popupComprovante && (
        <div style={modalFundo}>
          <div style={modal}>
            <h2>✅ Comprovante recebido</h2>

            <p style={{ color: "#64748b" }}>
              Valor detectado: <strong>{popupComprovante.valor}</strong>
            </p>

            <label style={campoModal}>
              <strong>Valor lançado</strong>
              <input
                style={input}
                value={popupComprovante.valor}
                onChange={(e) =>
                  setPopupComprovante({
                    ...popupComprovante,
                    valor: formatarMoeda(e.target.value),
                  })
                }
              />
            </label>

            <div style={{ marginTop: 16 }}>
              <strong>Tipo:</strong>

              <label style={radioLinha}>
                <input
                  type="radio"
                  checked={tipoComprovante === "vendaNova"}
                  onChange={() => setTipoComprovante("vendaNova")}
                />
                Venda nova
              </label>

              <label style={radioLinha}>
                <input
                  type="radio"
                  checked={tipoComprovante === "renovacao"}
                  onChange={() => setTipoComprovante("renovacao")}
                />
                Renovação
              </label>
            </div>

            <div style={botoesModal}>
              <button
                style={botaoSecundario}
                onClick={() => setPopupComprovante(null)}
                disabled={confirmandoComprovante}
              >
                Cancelar
              </button>

              <button
                style={{
                  ...botaoPrincipal,
                  opacity: confirmandoComprovante ? 0.6 : 1,
                  cursor: confirmandoComprovante ? "not-allowed" : "pointer",
                }}
                disabled={confirmandoComprovante}
                onClick={confirmarComprovante}
              >
                {confirmandoComprovante ? "Lançando..." : "Confirmar lançamento"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function formatarValor(valor) {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

function Input({ label, value, onChange, type = "text" }) {
  return (
    <label style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      <strong>{label}</strong>
      <input
        type={type}
        min={type === "number" ? "0" : undefined}
        style={input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </label>
  );
}

function Card({ titulo, valor }) {
  return (
    <div style={card}>
      <p style={{ margin: 0, color: "#aaa" }}>{titulo}</p>
      <h2 style={{ margin: "8px 0 0" }}>{valor}</h2>
    </div>
  );
}

const container = {
  padding: "20px 14px",
  fontFamily: "Arial",
};

const acoesTopo = {
  marginBottom: 18,
};

const botaoUpload = {
  display: "inline-block",
  padding: "12px 18px",
  background: "#2563eb",
  color: "white",
  borderRadius: 10,
  cursor: "pointer",
  fontWeight: "bold",
};

const cards = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
  gap: 16,
  marginBottom: 24,
};

const card = {
  background: "#0f172a",
  color: "white",
  padding: 20,
  borderRadius: 14,
};

const aviso = {
  background: "#eff6ff",
  color: "#1e3a8a",
  padding: 14,
  borderRadius: 12,
  marginBottom: 20,
  fontWeight: "bold",
};

const boxExtrato = {
  background: "white",
  padding: 22,
  borderRadius: 14,
  marginBottom: 24,
  boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
};

const extratoTopo = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 14,
  marginBottom: 14,
  flexWrap: "wrap",
};

const extratoTitulo = {
  margin: 0,
};

const extratoVazio = {
  border: "1px dashed #cbd5e1",
  borderRadius: 12,
  padding: 16,
  color: "#64748b",
};

const extratoLista = {
  display: "flex",
  flexDirection: "column",
  gap: 10,
};

const extratoLinha = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 16,
  padding: 14,
  borderRadius: 12,
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
};

const extratoLinhaEsquerda = {
  display: "flex",
  flexDirection: "column",
  gap: 4,
};

const extratoMeta = {
  color: "#475569",
  fontSize: 14,
};

const extratoDescricao = {
  color: "#64748b",
};

const extratoLinhaDireita = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  gap: 4,
  whiteSpace: "nowrap",
};

const extratoAnexo = {
  color: "#2563eb",
  fontWeight: "bold",
  fontSize: 13,
  textDecoration: "none",
};

const botaoExcluirExtrato = {
  background: "#fee2e2",
  color: "#991b1b",
  border: "1px solid #fecaca",
  borderRadius: 8,
  padding: "6px 10px",
  cursor: "pointer",
  fontWeight: "800",
  fontSize: 12,
};

const box = {
  background: "#f8fafc",
  padding: 24,
  borderRadius: 14,
  marginBottom: 24,
};

const statusBox = {
  background: "#e0f2fe",
  color: "#075985",
  padding: 12,
  borderRadius: 10,
  marginBottom: 18,
  fontWeight: "bold",
};

const alertaAprovado = {
  background: "#dcfce7",
  color: "#166534",
  padding: 14,
  borderRadius: 10,
  marginTop: 14,
  fontWeight: "bold",
};

const alertaRejeitado = {
  background: "#fee2e2",
  color: "#991b1b",
  padding: 14,
  borderRadius: 10,
  marginTop: 14,
  fontWeight: "bold",
};

const alertaCorrecao = {
  background: "#dbeafe",
  color: "#1d4ed8",
  padding: 14,
  borderRadius: 10,
  marginTop: 14,
  fontWeight: "bold",
};

const alertaTexto = {
  margin: "8px 0 0",
  fontWeight: "bold",
};

const boxInterno = {
  background: "white",
  padding: 18,
  borderRadius: 12,
  marginTop: 20,
};

const gridForm = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
  gap: 16,
};

const input = {
  padding: 12,
  borderRadius: 8,
  border: "1px solid #ccc",
};

const gastoLinha = {
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: 10,
  marginBottom: 14,
};

const botaoPrincipal = {
  padding: "12px 20px",
  background: "#000",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: "bold",
};

const botaoAtualizar = {
  padding: "12px 20px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: "bold",
};

const botaoFecharRelatorio = {
  padding: "15px 24px",
  background: "linear-gradient(135deg, #16a34a, #22c55e)",
  color: "#fff",
  border: "none",
  borderRadius: 14,
  cursor: "pointer",
  fontWeight: "900",
  letterSpacing: 0.2,
  boxShadow: "0 0 22px rgba(34,197,94,.45)",
  animation: "pulseFecharRelatorio 2s infinite",
  textTransform: "uppercase",
};

const botaoSecundario = {
  padding: "10px 16px",
  background: "#e5e7eb",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const botaoBanco = {
  display: "inline-block",
  padding: "12px 18px",
  background: "#2563eb",
  color: "white",
  borderRadius: 10,
  cursor: "pointer",
  fontWeight: "bold",
  marginRight: 10,
};

const linkAnexo = {
  display: "inline-block",
  marginTop: 12,
  color: "#2563eb",
  fontWeight: "bold",
  textDecoration: "none",
};

const botoesFechamento = {
  display: "flex",
  gap: 12,
  flexWrap: "wrap",
};


const botaoRemover = {
  background: "#fee2e2",
  color: "#991b1b",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const linha = {
  display: "flex",
  justifyContent: "space-between",
  background: "white",
  padding: 14,
  borderRadius: 10,
  marginTop: 10,
  gap: 16,
};

const modalFundo = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.55)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const modal = {
  background: "white",
  padding: 28,
  borderRadius: 16,
  width: 420,
  maxWidth: "92vw",
  boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
};

const campoModal = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
  marginTop: 14,
};

const radioLinha = {
  display: "block",
  marginTop: 10,
};

const botoesModal = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  marginTop: 24,
};
